import { typeIdObj } from '@home/utils/buriedPoint';
import {
  CASCADER,
  DIGITAL_SEGMENT_MULTIPLE,
  METRIC_SELECT_FOR_KPI_TREND,
  METRICTABLE_DEVICE,
  MY_FILTER,
  // PLATFORM,
  PLATFORMCASCADER,
  PUBLISHER,
  RANGE_TIME,
  REGION,
  // METRIC_SUBKEY_SHORTCUT,
  METRIC_SUBKEY_METRIC_TYPE,
  // METRIC_SUBKEY_SHOT,
  // METRIC_SUBKEY_METRICS,
  METRIC_SUBKEY_SHOT_METRIC,
  METRIC_SUBKEY_SHOT_DATA_SOURCE,
} from '@intelligence/components/Filter/FilterBase/_config';

import type { pointInter as IBuriedPointCfg } from '@home/utils/buriedPoint';
import { typeIdObj } from '@home/utils/buriedPoint';
import {
  CASCADER,
  DIGITAL_SEGMENT_MULTIPLE,
  METRIC_SELECT_FOR_KPI_TREND,
  METRICTABLE_DEVICE,
  MY_FILTER,
  // PLATFORM,
  PLATFORMCASCADER,
  PUBLISHER,
  RANGE_TIME,
  REGION,
  // METRIC_SUBKEY_SHORTCUT,
  METRIC_SUBKEY_METRIC_TYPE,
  // METRIC_SUBKEY_SHOT,
  // METRIC_SUBKEY_METRICS,
  METRIC_SUBKEY_SHOT_METRIC,
  METRIC_SUBKEY_SHOT_DATA_SOURCE,
} from '@intelligence/components/Filter/FilterBase/_config';

import type { pointInter as IBuriedPointCfg } from '@home/utils/buriedPoint';

// 页面打点配置表
export const dbiPageLogMes: {
  [key: string]: IBuriedPointCfg;
} = {
  aiDailyNews: {
    pageId: '308801',
    pageName: 'aiDailyNews',
    pagePath: '/lowCodeTemplate',
    typeId: typeIdObj.intelligence,
  },
  aiDailyNewsAIIndustry: {
    pageId: '308803',
    pageName: 'aiDailyNewsAIIndustry',
    pagePath: '/aiDailyNews/AIIndustry',
    typeId: typeIdObj.intelligence,
  },
  /** PC端-情报 Topchart-MobileGame-ActiverUser*/
  topchartsMobileGamesActiveUsers: {
    pageId: '300101',
    pageName: 'topchartsMobileGamesActiveUsers',
    pagePath: '/TopCharts/MobileGames/ActiveUsers',
    typeId: typeIdObj.intelligence,
  },
  topchartsMobileGamesRevenue: {
    pageId: '300102',
    pageName: 'topchartsMobileGamesRevenue',
    pagePath: '/TopCharts/MobileGames/Revenue',
    typeId: typeIdObj.intelligence,
  },
  topchartsMobileGamesDownloads: {
    pageId: '300103',
    pageName: 'topchartsMobileGamesDownloads',
    pagePath: '/TopCharts/MobileGames/Downloads',
    typeId: typeIdObj.intelligence,
  },
  topchartsMobileGamesDataBrainCalibration: {
    pageId: '300104',
    pageName: 'topchartsMobileGamesDataBrainCalibration',
    pagePath: '/TopCharts/MobileGames/DataBrainCalibration',
    typeId: typeIdObj.intelligence,
  },
  topchartsMobileGamesRPD: {
    pageId: '300105',
    pageName: 'topchartsMobileGamesRPD',
    pagePath: '/TopCharts/MobileGames/RPD',
    typeId: typeIdObj.intelligence,
  },
  topChartsMobileGamesRetention: {
    pageId: '300106',
    pageName: 'topChartsMobileGamesRetention',
    pagePath: '/TopCharts/MobileGames/Retention',
    typeId: typeIdObj.intelligence,
  },
  topchartsMobileGamesNewRelease: {
    pageId: '300107',
    pageName: 'topchartsMobileGamesNewRelease',
    pagePath: '/TopCharts/MobileGames/NewRelease',
    typeId: typeIdObj.intelligence,
  },
  topchartsMobileGamesUpcoming: {
    pageId: '300108',
    pageName: 'topchartsMobileGamesUpcoming',
    pagePath: '/TopCharts/MobileGames/Upcoming',
    typeId: typeIdObj.intelligence,
  },
  topchartMobileGamesDemographics: {
    pageId: '300109',
    pageName: 'topchartMobileGamesDemographics',
    pagePath: '/TopCharts/MobileGames/Demographics',
    typeId: typeIdObj.intelligence,
  },
  topchartOverlapAnalysisMobileGames: {
    pageId: '300110',
    pageName: 'topchartOverlapAnalysisMobileGames',
    pagePath: '/overlapAnalysis/mobileGames',
    typeId: typeIdObj.intelligence,
  },
  topchartOverlapAnalysisSteamGames: {
    pageId: '300111',
    pageName: 'topchartOverlapAnalysisSteamGames',
    pagePath: '/overlapAnalysis/steamGames',
    typeId: typeIdObj.intelligence,
  },
  potentialNewReleaseGamesMobileGame: {
    pageId: '300201',
    pageName: 'potentialNewReleaseGamesMobileGame',
    pagePath: '/Potential/NewReleaseGames/MobileGame',
    typeId: typeIdObj.intelligence,
  },
  potentialNewReleaseGamesPCGame: {
    pageId: '300202',
    pageName: 'potentialNewReleaseGamesPCGame',
    pagePath: '/Potential/NewReleaseGames/PCGame',
    typeId: typeIdObj.intelligence,
  },
  potentialNewReleaseGamesConsoleGame: {
    pageId: '300203',
    pageName: 'potentialNewReleaseGamesConsoleGame',
    pagePath: '/Potential/NewReleaseGames/ConsoleGame',
    typeId: typeIdObj.intelligence,
  },
  potentialUpcomingGamesMobileGame: {
    pageId: '300301',
    pageName: 'potentialUpcomingGamesMobileGame',
    pagePath: '/Potential/UpcomingGames/MobileGame',
    typeId: typeIdObj.intelligence,
  },
  potentialUpcomingGamesPCGame: {
    pageId: '300302',
    pageName: 'potentialUpcomingGamesPCGame',
    pagePath: '/Potential/UpcomingGames/PCGame',
    typeId: typeIdObj.intelligence,
  },
  potentialUpcomingGamesConsoleGame: {
    pageId: '300303',
    pageName: 'potentialUpcomingGamesConsoleGame',
    pagePath: '/Potential/UpcomingGames/ConsoleGame',
    typeId: typeIdObj.intelligence,
  },
  // PC Console Compare PCU
  comparePCConsoleGamesPCU: {
    pageId: '300401',
    pageName: 'comparePCConsoleGamesPCU',
    pagePath: 'compare/pcConsoleGames/pcu',
    typeId: typeIdObj.intelligence,
  },
  // PC Console Compare MAU
  comparePCConsoleGamesMAU: {
    pageId: '300402',
    pageName: 'comparePCConsoleGamesMAU',
    pagePath: 'compare/pcConsoleGames/mau',
    typeId: typeIdObj.intelligence,
  },
  // PC Console Compare Digital Revenue
  comparePCConsoleGamesDigitalRevenue: {
    pageId: '300403',
    pageName: 'comparePCConsoleGamesDigitalRevenue',
    pagePath: 'compare/pcConsoleGames/digitalRevenue',
    typeId: typeIdObj.intelligence,
  },
  // PC Console Compare Physical Revenue
  comparePCConsoleGamesPhysicalRevenue: {
    pageId: '300404',
    pageName: 'comparePCConsoleGamesPhysicalRevenue',
    pagePath: 'compare/pcConsoleGames/physicalRevenue',
    typeId: typeIdObj.intelligence,
  },
  // PC Console Compare -beta
  comparePCConsoleGamesBeta: {
    pageId: '300410',
    pageName: 'comparePCConsoleGamesBeta',
    pagePath: 'compare/PcConsoleGamesBeta',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsOverview: {
    pageId: '300501',
    pageName: 'topchartsMobileGamesGameDetailsOverview',
    pagePath: '/TopCharts/MobileGames/GameDetails/Overview',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStatsActiveUsers: {
    pageId: '300601',
    pageName: 'topchartsMobileGamesGameDetailsStatsActiveUsers',
    pagePath: '/TopCharts/MobileGames/GameDetails/Stats/ActiveUsers',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStatsRevenue: {
    pageId: '300602',
    pageName: 'topchartsMobileGamesGameDetailsStatsRevenue',
    pagePath: '/TopCharts/MobileGames/GameDetails/Stats/Revenue',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStatsDownloads: {
    pageId: '300603',
    pageName: 'topchartsMobileGamesGameDetailsStatsDownloads',
    pagePath: '/TopCharts/MobileGames/GameDetails/Stats/Downloads',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStatsRetentionMonthly: {
    pageId: '300604',
    pageName: 'topchartsMobileGamesGameDetailsStatsRetentionMonthly',
    pagePath: '/TopCharts/MobileGames/GameDetails/Stats/RetentionMonthly',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStatsRetentionLifetime: {
    pageId: '300605',
    pageName: 'topchartsMobileGamesGameDetailsStatsLifetime',
    pagePath: '/TopCharts/MobileGames/GameDetails/Stats/RetentionLifetime',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStatsRPD: {
    pageId: '300606',
    pageName: 'topchartsMobileGamesGameDetailsStatsRPD',
    pagePath: '/TopCharts/MobileGames/GameDetails/Stats/RPD',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsCountriesActiveUsers: {
    pageId: '300701',
    pageName: 'topchartsMobileGamesGameDetailsCountriesActiveUsers',
    pagePath: '/TopCharts/MobileGames/GameDetails/Countries/ActiveUsers',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsCountriesRevenue: {
    pageId: '300702',
    pageName: 'topchartsMobileGamesGameDetailsCountriesRevenue',
    pagePath: '/TopCharts/MobileGames/GameDetails/Countries/Revenue',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsCountriesDownloads: {
    pageId: '300703',
    pageName: 'topchartsMobileGamesGameDetailsCountriesDownloads',
    pagePath: '/TopCharts/MobileGames/GameDetails/Countries/Downloads',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsCountriesRetentionMonthly: {
    pageId: '300704',
    pageName: 'topchartsMobileGamesGameDetailsCountriesRetentionMonthly',
    pagePath: '/TopCharts/MobileGames/GameDetails/Countries/RetentionMonthly',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsCountriesRetentionLifetime: {
    pageId: '300705',
    pageName: 'topchartsMobileGamesGameDetailsCountriesLifetime',
    pagePath: '/TopCharts/MobileGames/GameDetails/Countries/RetentionLifetime',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsCountriesRPD: {
    pageId: '300706',
    pageName: 'topchartsMobileGamesGameDetailsCountriesRPD',
    pagePath: '/TopCharts/MobileGames/GameDetails/Countries/RPD',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStoreRank: {
    pageId: '300801',
    pageName: 'topchartsMobileGamesGameDetailsStoreRankMarketCount',
    pagePath: '/TopCharts/MobileGames/GameDetails/StoreRank/MarketCount',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStoreRank: {
    pageId: '300802',
    pageName: 'topchartsPCGamesGameDetailsStoreRank',
    pagePath: '/TopCharts/PCGames/GameDetails/StoreRank',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsStoreRank: {
    pageId: '300803',
    pageName: 'topchartsConsoleGamesGameDetailsStoreRank',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/StoreRank',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStoreRankRankTrend: {
    pageId: '300808',
    pageName: 'topchartsMobileGamesGameDetailsStoreRankRankTrend',
    pagePath: '/TopCharts/MobileGames/GameDetails/StoreRank/RankTrend',
    typeId: typeIdObj.intelligence,
  },

  mobileGameDetailsStreamHourwatch: {
    pageId: '300901',
    pageName: 'topchartsMobileGamesGameDetailsStreamingHourswatched',
    pagePath: '/TopCharts/MobileGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStreamPeakCCV: {
    pageId: '300902',
    pageName: 'topchartsMobileGamesGameDetailsStreamingPeakCCV',
    pagePath: '/TopCharts/MobileGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStreamAvgCCV: {
    pageId: '300903',
    pageName: 'topchartsMobileGamesGameDetailsStreamingAvgCCV',
    pagePath: '/TopCharts/MobileGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStreamAirtime: {
    pageId: '300904',
    pageName: 'topchartsMobileGamesGameDetailsStreamingAirtime',
    pagePath: '/TopCharts/MobileGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsOverlap: {
    pageId: '300905',
    pageName: 'topchartsMobileGamesGameDetailsOverlap',
    pagePath: '/TopCharts/MobileGames/GameDetails/Overlap',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsOverlap: {
    pageId: '300906',
    pageName: 'topchartsPCGamesGameDetailsSteamOverlap',
    pagePath: '/TopCharts/pcGames/GameDetails/Overlap',
    typeId: typeIdObj.intelligence,
  },
  'pc&consoleGameDetailsOverlap': {
    pageId: '300907',
    pageName: 'topchartsPC&ConsoleGamesGameDetailsSteamOverlap',
    pagePath: '/TopCharts/pcGames/GameDetails/SteamOverlap',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStreamHourwatch: {
    pageId: '301001',
    pageName: 'topchartsPCGamesGameDetailsStreamingHourswatched',
    pagePath: '/TopCharts/PCGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStreamPeakCCV: {
    pageId: '301002',
    pageName: 'topchartsPCGamesGameDetailsStreamingPeakCCV',
    pagePath: '/TopCharts/PCGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStreamAvgCCV: {
    pageId: '301003',
    pageName: 'topchartsPCGamesGameDetailsStreamingAvgCCV',
    pagePath: '/TopCharts/PCGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStreamAirtime: {
    pageId: '301004',
    pageName: 'topchartsPCGamesGameDetailsStreamingAirtime',
    pagePath: '/TopCharts/PCGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsStreamHourwatch: {
    pageId: '301101',
    pageName: 'topchartsConsoleGamesGameDetailsStreamingHourswatched',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsStreamPeakCCV: {
    pageId: '301102',
    pageName: 'topchartsConsoleGamesGameDetailsStreamingPeakCCV',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsStreamAvgCCV: {
    pageId: '301103',
    pageName: 'topchartsConsoleGamesGameDetailsStreamingAvgCCV',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsStreamAirtime: {
    pageId: '301104',
    pageName: 'topchartsConsoleGamesGameDetailsStreamingAirtime',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCGamesMetricsTable: {
    pageId: '301201',
    pageName: 'topChartsPCGamesMetricsTable',
    pagePath: '/TopCharts/PCGames/MetricsTable',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCGamesPCU: {
    pageId: '301202',
    pageName: 'topChartsPCGamesPCU',
    pagePath: '/TopCharts/PCGames/PCU',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCGamesDigitalRevenue: {
    pageId: '301203',
    pageName: 'topChartsPCGamesDigitalRevenue',
    pagePath: '/TopCharts/PCGames/DigitalRevenue',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCGamesPhysicalRevenue: {
    pageId: '301204',
    pageName: 'topChartsPCGamesPhysicalRevenue',
    pagePath: '/TopCharts/PCGames/PhysicalRevenue',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCGamesSteamSales: {
    pageId: '301205',
    pageName: 'topChartsPCGamesSteamSales',
    pagePath: '/TopCharts/PCGames/SteamSales',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCGamesMAU: {
    pageId: '301206',
    pageName: 'topChartsPCGamesMAU',
    pagePath: '/TopCharts/PCGames/MAU',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCGamesLifetimePlayers: {
    pageId: '301207',
    pageName: 'topChartsPCGamesLifetimePlayers',
    pagePath: '/TopCharts/PCGames/LifetimePlayers',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCGamesNewRelease: {
    pageId: '301208',
    pageName: 'topChartsPCGamesNewRelease',
    pagePath: '/TopCharts/PCGames/NewRelease',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCGamesUpcoming: {
    pageId: '301209',
    pageName: 'topChartsPCGamesUpcoming',
    pagePath: '/TopCharts/PCGames/Upcoming',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCGamesBenchmark: {
    pageId: '301210',
    pageName: 'topChartsPCGamesBenchmark',
    pagePath: '/TopCharts/PCGames/Benchmark',
    typeId: typeIdObj.intelligence,
  },
  topChartsConsoleGamesMetricsTable: {
    pageId: '301301',
    pageName: 'topChartsConsoleGamesMetricsTable',
    pagePath: '/TopCharts/ConsoleGames/MetricsTable',
    typeId: typeIdObj.intelligence,
  },
  topChartsConsoleGamesDigitalRevenue: {
    pageId: '301302',
    pageName: 'topChartsConsoleGamesDigitalRevenue',
    pagePath: '/TopCharts/ConsoleGames/DigitalRevenue',
    typeId: typeIdObj.intelligence,
  },
  topChartsConsoleGamesPhysicalRevenue: {
    pageId: '301303',
    pageName: 'topChartsConsoleGamesPhysicalRevenue',
    pagePath: '/TopCharts/ConsoleGames/PhysicalRevenue',
    typeId: typeIdObj.intelligence,
  },
  topChartsConsoleGamesJapanSales: {
    pageId: '301304',
    pageName: 'topChartsConsoleGamesJapanSales',
    pagePath: '/TopCharts/ConsoleGames/JapanSales',
    typeId: typeIdObj.intelligence,
  },
  topChartsConsoleGamesMAU: {
    pageId: '301305',
    pageName: 'topChartsConsoleGamesMAU',
    pagePath: '/TopCharts/ConsoleGames/MAU',
    typeId: typeIdObj.intelligence,
  },
  topChartsConsoleGamesLifetimePlayers: {
    pageId: '301306',
    pageName: 'topChartsConsoleGamesLifetimePlayers',
    pagePath: '/TopCharts/ConsoleGames/LifetimePlayers',
    typeId: typeIdObj.intelligence,
  },
  topChartsConsoleGamesNewRelease: {
    pageId: '301307',
    pageName: 'topChartsConsoleGamesNewRelease',
    pagePath: '/TopCharts/ConsoleGames/NewRelease',
    typeId: typeIdObj.intelligence,
  },
  topChartsConsoleGamesUpcoming: {
    pageId: '301308',
    pageName: 'topChartsConsoleGamesUpcoming',
    pagePath: '/TopCharts/ConsoleGames/Upcoming',
    typeId: typeIdObj.intelligence,
  },
  topchartsCompanyRevenue: {
    pageId: '301401',
    pageName: 'topchartsCompanyRevenue',
    pagePath: '/TopCharts/Companies/Revenue',
    typeId: typeIdObj.intelligence,
  },
  topchartsCompanyDownloads: {
    pageId: '301402',
    pageName: 'topchartsCompanyDownloads',
    pagePath: '/TopCharts/Companies/Downloads',
    typeId: typeIdObj.intelligence,
  },
  topchartsCompanyMentions: {
    pageId: '301403',
    pageName: 'topchartsCompanyMentions',
    pagePath: '/TopCharts/Companies/Mentions',
    typeId: typeIdObj.intelligence,
  },
  // 公司详情页Summary
  companyDetailsSummary: {
    pageId: '301501',
    pageName: 'companyDetailsSummary',
    pagePath: '/TopCharts/Companies/gamesDetail/Summary',
    typeId: typeIdObj.intelligence,
  },
  // 公司详情页NewsActivity
  companyDetailsNewsActivity: {
    pageId: '301502',
    pageName: 'companyDetailsNewsActivity',
    pagePath: '/TopCharts/Companies/gamesDetail/NewsActivity',
    typeId: typeIdObj.intelligence,
  },
  // 公司详情页GamesStats
  // 'companyDetailsGamesStats': {
  //   pageId: '301503',
  //   pageName: 'companyDetailsGamesStats',
  //   pagePath: '/TopCharts/Companies/gamesDetail/GamesStats',
  //   typeId: typeIdObj.intelligence,
  // },
  // 公司详情页Financials
  companyDetailsFinancials: {
    pageId: '301504',
    pageName: 'companyDetailsFinancials',
    pagePath: '/TopCharts/Companies/gamesDetail/Financials',
    typeId: typeIdObj.intelligence,
  },
  // 公司详情页SubsidiaryCompanies
  companyDetailsSubsidiaryCompanies: {
    pageId: '301505',
    pageName: 'companyDetailsSubsidiaryCompanies',
    pagePath: '/TopCharts/Companies/gamesDetail/SubsidiaryCompanies',
    typeId: typeIdObj.intelligence,
  },
  // 公司详情页People
  companyDetailsPeople: {
    pageId: '301506',
    pageName: 'companyDetailsPeople',
    pagePath: '/TopCharts/Companies/gamesDetail/People',
    typeId: typeIdObj.intelligence,
  },
  // 公司详情页SimilarCompanies
  companyDetailsSimilarCompanies: {
    pageId: '301507',
    pageName: 'companyDetailsSimilarCompanies',
    pagePath: '/TopCharts/Companies/gamesDetail/SimilarCompanies',
    typeId: typeIdObj.intelligence,
  },
  companyDetailsGamesStatsMobileRevenue: {
    pageId: '301508',
    pageName: 'companyDetailsGamesStatsMobileRevenue',
    pagePath: '/TopCharts/Companies/gamesDetail/GamesStats/MobileMetrics',
    typeId: typeIdObj.intelligence,
  },
  companyDetailsGamesStatsMobileDownloads: {
    pageId: '301509',
    pageName: 'companyDetailsGamesStatsMobileDownloads',
    pagePath: '/TopCharts/Companies/gamesDetail/GamesStats/MobileMetrics',
    typeId: typeIdObj.intelligence,
  },
  companyDetailsGamesStatsPCDigitalRevenue: {
    pageId: '301510',
    pageName: 'companyDetailsGamesStatsPCDigitalRevenue',
    pagePath: '/TopCharts/Companies/gamesDetail/GamesStats/PCMetrics',
    typeId: typeIdObj.intelligence,
  },
  companyDetailsGamesStatsPCPhysicalRevenue: {
    pageId: '301511',
    pageName: 'companyDetailsGamesStatsPCPhysicalRevenue',
    pagePath: '/TopCharts/Companies/gamesDetail/GamesStats/PCMetrics',
    typeId: typeIdObj.intelligence,
  },
  companyDetailsGamesStatsPCPCU: {
    pageId: '301512',
    pageName: 'companyDetailsGamesStatsPCPCU',
    pagePath: '/TopCharts/Companies/gamesDetail/GamesStats/PCMetrics',
    typeId: typeIdObj.intelligence,
  },
  companyDetailsGamesStatsPCMAU: {
    pageId: '301513',
    pageName: 'companyDetailsGamesStatsPCMAU',
    pagePath: '/TopCharts/Companies/gamesDetail/GamesStats/PCMetrics',
    typeId: typeIdObj.intelligence,
  },
  companyDetailsGamesStatsConsoleDigitalRevenue: {
    pageId: '301514',
    pageName: 'companyDetailsGamesStatsConsoleDigitalRevenue',
    pagePath: '/TopCharts/Companies/gamesDetail/GamesStats/ConsoleMetrics',
    typeId: typeIdObj.intelligence,
  },
  companyDetailsGamesStatsConsolePhysicalRevenue: {
    pageId: '301515',
    pageName: 'companyDetailsGamesStatsConsolePhysicalRevenue',
    pagePath: '/TopCharts/Companies/gamesDetail/GamesStats/ConsoleMetrics',
    typeId: typeIdObj.intelligence,
  },
  companyDetailsGamesStatsConsoleMAU: {
    pageId: '301516',
    pageName: 'companyDetailsGamesStatsConsoleMAU',
    pagePath: '/TopCharts/Companies/gamesDetail/GamesStats/ConsoleMetrics',
    typeId: typeIdObj.intelligence,
  },
  companyDetailsGamesStatsGamesOwned: {
    pageId: '301517',
    pageName: 'companyDetailsGamesStatsGamesOwned',
    pagePath: '/TopCharts/Companies/gamesDetail/GamesStats/GamesOwned',
    typeId: typeIdObj.intelligence,
  },
  // TrendingGames
  trendingGames: {
    pageId: '302601',
    pageName: 'trendingGames',
    pagePath: '/reports/trendingGames',
    typeId: typeIdObj.intelligence,
  },
  // mobile device
  mobileDeviceOverview: {
    pageId: '302701',
    pageName: 'mobileDeviceOverview',
    pagePath: '/mobileDevice/overview',
    typeId: typeIdObj.intelligence,
  },
  mobileDeviceReports: {
    pageId: '302702',
    pageName: 'mobileDeviceReports',
    pagePath: '/mobileDevice/reports',
    typeId: typeIdObj.intelligence,
  },
  // Report Search 报告搜索页面
  reportSearch: {
    pageId: '302912',
    pageName: 'reportSearch',
    pagePath: '/reports/reportSearch',
    typeId: typeIdObj.intelligence,
  },
  // AI Hub Reports
  aiHubReports: {
    pageId: '302901',
    pageName: 'aiHubReports',
    extInfo: 'All',
    pagePath: '/reports/aiHubReports',
    typeId: typeIdObj.intelligence,
  },
  aiHubReportsGameAI: {
    pageId: '302902',
    pageName: 'aiHubReports',
    extInfo: 'Game AI',
    pagePath: '/reports/aiHubReports',
    typeId: typeIdObj.intelligence,
  },
  aiHubReportsAIAssets: {
    pageId: '302903',
    pageName: 'aiHubReports',
    extInfo: 'AI Assets',
    pagePath: '/reports/aiHubReports',
    typeId: typeIdObj.intelligence,
  },
  // Insight Report
  insightsReports: {
    pageId: '302801',
    pageName: 'insightsReports',
    extInfo: 'All',
    pagePath: '/reports/insightsReports',
    typeId: typeIdObj.intelligence,
  },
  insightsReportsGeneralGaming: {
    pageId: '302802',
    pageName: 'insightsReports',
    extInfo: 'General Gaming',
    pagePath: '/reports/insightsReports',
    typeId: typeIdObj.intelligence,
  },
  insightsReportsEsports: {
    pageId: '302803',
    pageName: 'insightsReports',
    extInfo: 'Esports',
    pagePath: '/reports/insightsReports',
    typeId: typeIdObj.intelligence,
  },
  insightsReportsMarkets: {
    pageId: '302804',
    pageName: 'insightsReports',
    extInfo: 'Markets',
    pagePath: '/reports/insightsReports',
    typeId: typeIdObj.intelligence,
  },
  insightsReportsGameGenres: {
    pageId: '302805',
    pageName: 'insightsReports',
    extInfo: 'Game & Genres',
    pagePath: '/reports/insightsReports',
    typeId: typeIdObj.intelligence,
  },
  insightsReportsPlayers: {
    pageId: '302806',
    pageName: 'insightsReports',
    extInfo: 'Players',
    pagePath: '/reports/insightsReports',
    typeId: typeIdObj.intelligence,
  },
  insightsReportsMonetization: {
    pageId: '302807',
    pageName: 'insightsReports',
    extInfo: 'Monetization',
    pagePath: '/reports/insightsReports',
    typeId: typeIdObj.intelligence,
  },
  insightsReportsCompliance: {
    pageId: '302808',
    pageName: 'insightsReports',
    extInfo: 'Compliance',
    pagePath: '/reports/insightsReports',
    typeId: typeIdObj.intelligence,
  },
  // Insights Center Library
  insightsCenterLibrary: {
    pageId: '302811',
    pageName: 'insightsCenterLibrary',
    extInfo: 'All',
    pagePath: '/reports/insightsCenterLibrary',
    typeId: typeIdObj.intelligence,
  },
  insightsCenterLibraryFundamentalStudy: {
    pageId: '302812',
    pageName: 'insightsCenterLibrary',
    extInfo: 'Fundamental Study',
    pagePath: '/reports/insightsCenterLibrary',
    typeId: typeIdObj.intelligence,
  },
  insightsCenterLibraryGRIP: {
    pageId: '302813',
    pageName: 'insightsCenterLibrary',
    extInfo: 'GRIP',
    pagePath: '/reports/insightsCenterLibrary',
    typeId: typeIdObj.intelligence,
  },
  // insightsCenterLibraryAdHocResearch: {
  //   pageId: '302814',
  //   pageName: 'insightsCenterLibrary',
  //   extInfo: 'Ad-Hoc Research',
  //   pagePath: '/reports/insightsCenterLibrary',
  //   typeId: typeIdObj.intelligence,
  // },
  insightsCenterLibraryRegionalMonthlyReport: {
    pageId: '302815',
    pageName: 'insightsCenterLibrary',
    extInfo: 'Regional Monthly Report',
    pagePath: '/reports/insightsCenterLibrary',
    typeId: typeIdObj.intelligence,
  },
  // iMur Report
  iMurReports: {
    pageId: '302901',
    pageName: 'iMurReports',
    pagePath: '/reports/iMurReports',
    typeId: typeIdObj.intelligence,
  },
  // SOC Discount Report
  socDiscountReport: {
    pageId: '302911',
    pageName: 'socDiscountReport',
    pagePath: '/reports/socDiscountReport',
    typeId: typeIdObj.intelligence,
  },
  iMurReportsAll: {
    pageId: '302903',
    pageName: 'iMurReportsAll',
    pagePath: '/reports/iMurReports',
    typeId: typeIdObj.intelligence,
  },
  iMurReportsWhitePapers: {
    pageId: '302904',
    pageName: 'iMurReportsWhitePapers',
    pagePath: '/reports/iMurReports',
    typeId: typeIdObj.intelligence,
  },
  iMurReportsMonitoringReports: {
    pageId: '302905',
    pageName: 'iMurReportsMonitoringReports',
    pagePath: '/reports/iMurReports',
    typeId: typeIdObj.intelligence,
  },
  iMurReportsGenresCompetitors: {
    pageId: '302906',
    pageName: 'iMurReportsGenresCompetitors',
    pagePath: '/reports/iMurReports',
    typeId: typeIdObj.intelligence,
  },
  iMurReportsOperationPublishing: {
    pageId: '302907',
    pageName: 'iMurReportsOperationPublishing',
    pagePath: '/reports/iMurReports',
    typeId: typeIdObj.intelligence,
  },
  iMurReportsSpecificReports: {
    pageId: '302908',
    pageName: 'iMurReportsSpecificReports',
    pagePath: '/reports/iMurReports',
    typeId: typeIdObj.intelligence,
  },
  iMurReportsGameCompaines: {
    pageId: '302909',
    pageName: 'iMurReportsGameCompaines',
    pagePath: '/reports/iMurReports',
    typeId: typeIdObj.intelligence,
  },
  iMurReportsNewTech: {
    pageId: '302910',
    pageName: 'iMurReportsNewTech',
    pagePath: '/reports/iMurReports',
    typeId: typeIdObj.intelligence,
  },

  // Market Report
  MarketReports: {
    pageId: '303001',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'newzoo',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsStatista: {
    pageId: '303002',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'statista',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsSensortower: {
    pageId: '303003',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'sensortower',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsDataAi: {
    pageId: '303004',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'data.ai',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsStreamHatchet: {
    pageId: '303005',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'streamhatchet',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsNPD: {
    pageId: '303006',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'npd',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsFamitsu: {
    pageId: '303007',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'famitsu',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsTwitter: {
    pageId: '303008',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'twitter',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsFandom: {
    pageId: '303009',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'fandom',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsOthers: {
    pageId: '303010',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'others',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsOtherVendors: {
    pageId: '303011',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'OtherVendors',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsVGI: {
    pageId: '303012',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'vgi',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsAppMagic: {
    pageId: '303013',
    pageName: 'MarketReports',
    pagePath: '/reports/MarketReports',
    extInfo: 'appmagic',
    typeId: typeIdObj.intelligence,
  },
  // source & metrics
  sourcesMetricsOverview: {
    pageId: '303101',
    pageName: 'sourcesMetricsOverview',
    pagePath: '/sourcesMetrics/overview',
    typeId: typeIdObj.intelligence,
  },
  sourcesMetricsSourcesIntelligenceSources: {
    pageId: '303102',
    pageName: 'sourcesMetricsSourcesIntelligenceSources',
    pagePath: '/sourcesMetrics/Sources/IntelligenceSources',
    typeId: typeIdObj.intelligence,
  },
  sourcesMetricsSourcesOpinionsSources: {
    pageId: '303103',
    pageName: 'sourcesMetricsSourcesOpinionsSources',
    pagePath: '/sourcesMetrics/Sources/OpinionsSources',
    typeId: typeIdObj.intelligence,
  },
  sourcesMetricsSourcesNewsCrawlers: {
    pageId: '303104',
    pageName: 'sourcesMetricsSourcesNewsCrawlers',
    pagePath: '/sourcesMetrics/Sources/NewsCrawlers',
    typeId: typeIdObj.intelligence,
  },
  sourcesMetricsMetricsIntelligenceMetrics: {
    pageId: '303105',
    pageName: 'sourcesMetricsMetricsIntelligenceMetrics',
    pagePath: '/sourcesMetrics/Sources/IntelligenceMetrics',
    typeId: typeIdObj.intelligence,
  },
  sourcesMetricsMetricsOpinionsMetrics: {
    pageId: '303106',
    pageName: 'sourcesMetricsMetricsOpinionsMetrics',
    pagePath: '/sourcesMetrics/Metrics/OpinionsMetrics',
    typeId: typeIdObj.intelligence,
  },
  sourcesMetricsMetricsMobileGameFields: {
    pageId: '303107',
    pageName: 'sourcesMetricsMetricsMobileGameFields',
    pagePath: '/sourcesMetrics/Sources/MobileGameFields',
    typeId: typeIdObj.intelligence,
  },
  sourcesMetricsMetricsPCConsoleFields: {
    pageId: '303108',
    pageName: 'sourcesMetricsMetricsPCConsoleFields',
    pagePath: '/sourcesMetrics/Sources/PCConsoleFields',
    typeId: typeIdObj.intelligence,
  },
  sourcesMetricsMetricsCompanyFields: {
    pageId: '303109',
    pageName: 'sourcesMetricsMetricsCompanyFields',
    pagePath: '/sourcesMetrics/Sources/CompanyFields',
    typeId: typeIdObj.intelligence,
  },
  sourcesMetricsMetricsDeviceMetrics: {
    pageId: '303110',
    pageName: 'sourcesMetricsMetricsDeviceMetrics',
    pagePath: '/sourcesMetrics/metrics/DeviceMetrics',
    typeId: typeIdObj.intelligence,
  },

  pcGameDetailsOverview: {
    pageId: '301701',
    pageName: 'topchartsPCGamesGameDetailsOverview',
    pagePath: '/TopCharts/PCGames/GameDetails/Overview',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStatsPCU: {
    pageId: '301801',
    pageName: 'topchartsPCGamesGameDetailsStatsPCU',
    pagePath: '/TopCharts/PCGames/GameDetails/Stats/PCU',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStatsDigitalRevenue: {
    pageId: '301802',
    pageName: 'topchartsPCGamesGameDetailsStatsDigitalRevenue',
    pagePath: '/TopCharts/PCGames/GameDetails/Stats/DigitalRevenue',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStatsPhysicalRevenue: {
    pageId: '301803',
    pageName: 'topchartsPCGamesGameDetailsStatsPhysicalRevenue',
    pagePath: '/TopCharts/PCGames/GameDetails/Stats/PhysicalRevenue',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStatsSteamSales: {
    pageId: '301804',
    pageName: 'topchartsPCGamesGameDetailsStatsSteamSales',
    pagePath: '/TopCharts/PCGames/GameDetails/Stats/SteamSales',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStatsNewzooMetrics: {
    pageId: '301805',
    pageName: 'topchartsPCGamesGameDetailsStatsNewzooMetrics',
    pagePath: '/TopCharts/PCGames/GameDetails/Stats/NewzooMetrics',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStatsGSDSaleData: {
    pageId: '301806',
    pageName: 'topchartsPCGamesGameDetailsStatsGSDSaleData',
    pagePath: '/TopCharts/PCGames/GameDetails/Stats/GSDSaleData',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsCountriesPCU: {
    pageId: '301901',
    pageName: 'topchartsPCGamesGameDetailsCountriesPCU',
    pagePath: '/TopCharts/PCGames/GameDetails/Countries/PCU',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsCountriesDigitalRevenue: {
    pageId: '301902',
    pageName: 'topchartsPCGamesGameDetailsCountriesDigitalRevenue',
    pagePath: '/TopCharts/PCGames/GameDetails/Countries/DigitalRevenue',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsCountriesPhysicalRevenue: {
    pageId: '301903',
    pageName: 'topchartsPCGamesGameDetailsCountriesPhysicalRevenue',
    pagePath: '/TopCharts/PCGames/GameDetails/Countries/PhysicalRevenue',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsCountriesSteamSales: {
    pageId: '301904',
    pageName: 'topchartsPCGamesGameDetailsCountriesSteamSales',
    pagePath: '/TopCharts/PCGames/GameDetails/Countries/SteamSales',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsCountriesNewzooMetrics: {
    pageId: '301905',
    pageName: 'topchartsPCGamesGameDetailsCountriesNewzooMetrics',
    pagePath: '/TopCharts/PCGames/GameDetails/Countries/NewzooMetrics',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsCountriesGSDSaleData: {
    pageId: '301906',
    pageName: 'topchartsPCGamesGameDetailsCountriesGSDSaleData',
    pagePath: '/TopCharts/PCGames/GameDetails/Countries/GSDSaleData',
    typeId: typeIdObj.intelligence,
  },

  consoleGameDetailsOverview: {
    pageId: '302001',
    pageName: 'topchartsConsoleGamesGameDetailsOverview',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Overview',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsStatsDigitalRevenue: {
    pageId: '302101',
    pageName: 'topchartsConsoleGamesGameDetailsStatsDigitalRevenue',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Stats/DigitalRevenue',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsStatsPhysicalRevenue: {
    pageId: '302102',
    pageName: 'topchartsConsoleGamesGameDetailsStatsPhysicalRevenue',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Stats/PhysicalRevenue',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsStatsJapanSales: {
    pageId: '302103',
    pageName: 'topchartsConsoleGamesGameDetailsStatsJapanSales',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Stats/JapanSales',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsStatsNewzooMetrics: {
    pageId: '302104',
    pageName: 'topchartsConsoleGamesGameDetailsStatsNewzooMetrics',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Stats/NewzooMetrics',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsStatsGSDSaleData: {
    pageId: '302105',
    pageName: 'topchartsConsoleGamesGameDetailsStatsGSDSaleData',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Stats/GSDSaleData',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsCountriesDigitalRevenue: {
    pageId: '302201',
    pageName: 'topchartsConsoleGamesGameDetailsCountriesDigitalRevenue',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Countries/DigitalRevenue',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsCountriesPhysicalRevenue: {
    pageId: '302202',
    pageName: 'topchartsConsoleGamesGameDetailsCountriesPhysicalRevenue',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Countries/PhysicalRevenue',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsCountriesJapanSales: {
    pageId: '302203',
    pageName: 'topchartsConsoleGamesGameDetailsCountriesJapanSales',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Countries/JapanSales',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsCountriesNewzooMetrics: {
    pageId: '302204',
    pageName: 'topchartsConsoleGamesGameDetailsCountriesNewzooMetrics',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Countries/NewzooMetrics',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsCountriesGSDSaleData: {
    pageId: '302205',
    pageName: 'topchartsConsoleGamesGameDetailsCountriesGSDSaleData',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Countries/GSDSaleData',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopGenrePerMarketTotalMarket: {
    pageId: '301601',
    pageName: 'globalViewTopGenrePerMarketTotalMarket',
    pagePath: '/GlobalView/TopGenrePerMarket/TotalMarket',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopGenrePerMarketMobileGames: {
    pageId: '301602',
    pageName: 'globalViewTopGenrePerMarketMobileGames',
    pagePath: '/GlobalView/TopGenrePerMarket/MobileGames',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopGenrePerMarketPCGames: {
    pageId: '301603',
    pageName: 'globalViewTopGenrePerMarketPCGames',
    pagePath: '/GlobalView/TopGenrePerMarket/PCGames',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopGenrePerMarketConsoleGames: {
    pageId: '301604',
    pageName: 'globalViewTopGenrePerMarketConsoleGames',
    pagePath: '/GlobalView/TopGenrePerMarket/ConsoleGames',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopMarketPerGenreTotalMarket: {
    pageId: '301605',
    pageName: 'globalViewTopMarketPerGenreTotalMarket',
    pagePath: '/GlobalView/TopMarketPerGenre/TotalMarket',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopMarketPerGenreMobileGames: {
    pageId: '301606',
    pageName: 'globalViewTopMarketPerGenreMobileGames',
    pagePath: '/GlobalView/TopMarketPerGenre/MobileGames',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopMarketPerGenrePCGames: {
    pageId: '301607',
    pageName: 'globalViewTopMarketPerGenrePCGames',
    pagePath: '/GlobalView/TopMarketPerGenre/PCGames',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopMarketPerGenreConsoleGames: {
    pageId: '301608',
    pageName: 'globalViewTopMarketPerGenreConsoleGames',
    pagePath: '/GlobalView/TopMarketPerGenre/ConsoleGames',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankGlobalCompare: {
    pageId: '302301',
    pageName: 'mobileStoreRankGlobalCompare',
    pagePath: '/storeRanks/MobileGlobalRegion/globalcompare',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankTop: {
    pageId: '302302',
    pageName: 'mobileStoreRankTop',
    pagePath: '/storeRanks/MobileGlobalRegion',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreAppstoreTopFree: {
    pageId: '302310',
    pageName: 'mobileStoreRankMoreAppstoreTopFree',
    pagePath: '/storeRanks/MobileGlobalRegion/more',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreAppstoreTopGrossing: {
    pageId: '302311',
    pageName: 'mobileStoreRankMoreAppstoreTopGrossing',
    pagePath: '/storeRanks/MobileGlobalRegion/more',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreAppstoreTopPaid: {
    pageId: '302312',
    pageName: 'mobileStoreRankMoreAppstoreTopPaid',
    pagePath: '/storeRanks/MobileGlobalRegion/more',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopFree: {
    pageId: '302313',
    pageName: 'mobileStoreRankMoreGoogleplayTopFree',
    pagePath: '/storeRanks/MobileGlobalRegion/more',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopGrossing: {
    pageId: '302314',
    pageName: 'mobileStoreRankMoreGoogleplayTopGrossing',
    pagePath: '/storeRanks/MobileGlobalRegion/more',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopPaid: {
    pageId: '302315',
    pageName: 'mobileStoreRankMoreGoogleplayTopPaid',
    pagePath: '/storeRanks/MobileGlobalRegion/more',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopPopular: {
    pageId: '302316',
    pageName: 'mobileStoreRankMoreGoogleplayTopPopular',
    pagePath: '/storeRanks/MobileGlobalRegion/more',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopNewFree: {
    pageId: '302317',
    pageName: 'mobileStoreRankMoreGoogleplayTopNewFree',
    pagePath: '/storeRanks/MobileGlobalRegion/more',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopNewPaid: {
    pageId: '302318',
    pageName: 'mobileStoreRankMoreGoogleplayTopNewPaid',
    pagePath: '/storeRanks/MobileGlobalRegion/more',
    typeId: typeIdObj.intelligence,
  },
  minigameStoreRankMoreWechatPopularity: {
    pageId: '302319',
    pageName: 'minigameStoreRankMoreWechatPopularity',
    pagePath: '/casualGamesHub/casualMiniGameRankings/more',
    typeId: typeIdObj.intelligence,
  },
  minigameStoreRankMoreWechatBestsellery: {
    pageId: '302320',
    pageName: 'minigameStoreRankMoreWechatBestsellery',
    pagePath: '/casualGamesHub/casualMiniGameRankings/more',
    typeId: typeIdObj.intelligence,
  },
  minigameStoreRankMoreWechatMostPlayed: {
    pageId: '302321',
    pageName: 'minigameStoreRankMoreWechatMostPlayed',
    pagePath: '/casualGamesHub/casualMiniGameRankings/more',
    typeId: typeIdObj.intelligence,
  },
  minigameStoreRankMoreDouyinPopularity: {
    pageId: '302322',
    pageName: 'minigameStoreRankMoreDouyinPopularity',
    pagePath: '/casualGamesHub/casualMiniGameRankings/more',
    typeId: typeIdObj.intelligence,
  },
  minigameStoreRankMoreDouyinBestsellery: {
    pageId: '302323',
    pageName: 'minigameStoreRankMoreDouyinBestsellery',
    pagePath: '/casualGamesHub/casualMiniGameRankings/more',
    typeId: typeIdObj.intelligence,
  },
  minigameStoreRankMoreDouyinMostPlayed: {
    pageId: '302324',
    pageName: 'minigameStoreRankMoreDouyinMostPlayed',
    pagePath: '/casualGamesHub/casualMiniGameRankings/more',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankTopSteam: {
    pageId: '302330',
    pageName: 'storeRanksPCGlobalSteam',
    pagePath: '/storeRanks/PCGlobal',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankTopEpic: {
    pageId: '302331',
    pageName: 'storeRanksPCGlobalEpic',
    pagePath: '/storeRanks/PCGlobal',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreSteamTopSellers: {
    pageId: '302340',
    pageName: 'pcStoreRankMoreSteamTopSellers',
    pagePath: '/storeRanks/PCGlobal/more',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreSteamMostPlayed: {
    pageId: '302341',
    pageName: 'pcStoreRankMoreSteamMostPlayed',
    pagePath: '/storeRanks/PCGlobal/more',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreSteamNewAndTrending: {
    pageId: '302342',
    pageName: 'pcStoreRankMoreSteamNewAndTrending',
    pagePath: '/storeRanks/PCGlobal/more',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreSteamTopWishLists: {
    pageId: '302343',
    pageName: 'pcStoreRankMoreSteamTopWishLists',
    pagePath: '/storeRanks/PCGlobal/more',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreEpicTopSellers: {
    pageId: '302344',
    pageName: 'pcStoreRankMoreEpicTopSellers',
    pagePath: '/storeRanks/PCGlobal/more',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreEpicTopPopular: {
    pageId: '302345',
    pageName: 'pcStoreRankMoreEpicTopPopular',
    pagePath: '/storeRanks/PCGlobal/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankTopPlaystation: {
    pageId: '302360',
    pageName: 'consoleStoreRankTopPlaystation',
    pagePath: '/storeRanks/ConsoleRegion',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankTopXbox: {
    pageId: '302361',
    pageName: 'consoleStoreRankTopXbox',
    pagePath: '/storeRanks/ConsoleRegion',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankTopNintendo: {
    pageId: '302362',
    pageName: 'consoleStoreRankTopNintendo',
    pagePath: '/storeRanks/ConsoleRegion',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationBestSelling: {
    pageId: '302370',
    pageName: 'consoleStoreRankMorePlaystationBestSelling',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationMostDownloaded: {
    pageId: '302371',
    pageName: 'consoleStoreRankMorePlaystationMostDownloaded',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationNewGames: {
    pageId: '302372',
    pageName: 'consoleStoreRankMorePlaystationNewGames',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationComingSoon: {
    pageId: '302373',
    pageName: 'consoleStoreRankMorePlaystationComingSoon',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationIndiesGames: {
    pageId: '302374',
    pageName: 'consoleStoreRankMorePlaystationIndiesGames',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationFreeToPlay: {
    pageId: '302375',
    pageName: 'consoleStoreRankMorePlaystationFreeToPlay',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationPS5MostDownloaded: {
    pageId: '302376',
    pageName: 'consoleStoreRankMorePlaystationPS5MostDownloaded',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationPS4MostDownloaded: {
    pageId: '302377',
    pageName: 'consoleStoreRankMorePlaystationPS4MostDownloaded',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationVRGames: {
    pageId: '302378',
    pageName: 'consoleStoreRankMorePlaystationVRGames',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxNewRelease: {
    pageId: '302379',
    pageName: 'consoleStoreRankMoreXboxNewRelease',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxUpcoming: {
    pageId: '302380',
    pageName: 'consoleStoreRankMoreXboxUpcoming',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxMostPlayed: {
    pageId: '302381',
    pageName: 'consoleStoreRankMoreXboxMostPlayed',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreNintendoBestSellers: {
    pageId: '302382',
    pageName: 'consoleStoreRankMoreNintendoBestSellers',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreNintendoNewRelease: {
    pageId: '302383',
    pageName: 'consoleStoreRankMoreNintendoNewRelease',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreNintendoComingSoon: {
    pageId: '302384',
    pageName: 'consoleStoreRankMoreNintendoComingSoon',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxBestRated: {
    pageId: '302385',
    pageName: 'consoleStoreRankMoreXboxBestRated',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxTopFree: {
    pageId: '302386',
    pageName: 'consoleStoreRankMoreXboxTopFree',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxTopPaid: {
    pageId: '302387',
    pageName: 'consoleStoreRankMoreXboxTopPaid',
    pagePath: '/storeRanks/ConsoleRegion/more',
    typeId: typeIdObj.intelligence,
  },
  followingCurrentGamesMobile: {
    pageId: '302401',
    pageName: 'followingCurrentGamesMobile',
    pagePath: '/Following/CurrentGames',
    typeId: typeIdObj.intelligence,
  },
  followingCurrentGamesPC: {
    pageId: '302402',
    pageName: 'followingCurrentGamesPC',
    pagePath: '/Following/CurrentGames',
    typeId: typeIdObj.intelligence,
  },
  followingCurrentGamesConsole: {
    pageId: '302403',
    pageName: 'followingCurrentGamesConsole',
    pagePath: '/Following/CurrentGames',
    typeId: typeIdObj.intelligence,
  },
  followingCurrentGamesCompanies: {
    pageId: '302404',
    pageName: 'followingCurrentGamesCompanies',
    pagePath: '/Following/CurrentGames',
    typeId: typeIdObj.intelligence,
  },
  followingNewGamesMobile: {
    pageId: '302405',
    pageName: 'followingNewGamesMobile',
    pagePath: '/Following/NewGames',
    typeId: typeIdObj.intelligence,
  },
  followingNewGamesPC: {
    pageId: '302406',
    pageName: 'followingNewGamesPC',
    pagePath: '/Following/NewGames',
    typeId: typeIdObj.intelligence,
  },
  followingNewGamesConsole: {
    pageId: '302407',
    pageName: 'followingNewGamesConsole',
    pagePath: '/Following/NewGames',
    typeId: typeIdObj.intelligence,
  },
  followingManageMobile: {
    pageId: '302408',
    pageName: 'followingManageMobile',
    pagePath: '/Following/Manage',
    typeId: typeIdObj.intelligence,
  },
  followingManagePC: {
    pageId: '302409',
    pageName: 'followingManagePC',
    pagePath: '/Following/Manage',
    typeId: typeIdObj.intelligence,
  },
  followingManageConsole: {
    pageId: '302410',
    pageName: 'followingManageConsole',
    pagePath: '/Following/Manage',
    typeId: typeIdObj.intelligence,
  },
  followingManageCompanies: {
    pageId: '302411',
    pageName: 'followingManageCompanies',
    pagePath: '/Following/Manage',
    typeId: typeIdObj.intelligence,
  },
  followingManageSearch: {
    pageId: '302412',
    pageName: 'followingManageSearch',
    pagePath: '/Following/Manage',
    typeId: typeIdObj.intelligence,
  },

  // mobileGameBenchmark
  mobileGameBenchmarkFigure: {
    pageId: '303701',
    pageName: 'mobileGameBenchmark',
    pagePath: 'benchmark/mobileGameBenchmark',
    typeId: typeIdObj.intelligence,
  },

  mobileGameBenchmarkStatus: {
    pageId: '303702',
    pageName: 'mobileGameBenchmark',
    pagePath: 'benchmark/mobileGameBenchmark',
    typeId: typeIdObj.intelligence,
  },

  // pcConsoleBenchmark
  pcConsoleBenchmark: {
    pageId: '302601',
    pageName: 'pcConsoleBenchmark',
    pagePath: '/pcConsoleBenchmark',
    typeId: typeIdObj.intelligence,
  },

  pcConsoleBenchmarkFigure: {
    pageId: '302602',
    pageName: 'pcConsoleBenchmarkFigure',
    pagePath: '/pcConsoleBenchmark',
    typeId: typeIdObj.intelligence,
  },

  pcConsoleBenchmarkStats: {
    pageId: '302503',
    pageName: 'pcConsoleBenchmarkStats',
    pagePath: '/pcConsoleBenchmark',
    typeId: typeIdObj.intelligence,
  },

  // MarketProfile
  marketProfileMobile: {
    pageId: '91001',
    pageName: 'marketProfileMobileGames',
    pagePath: 'marketProfile/MobileGames',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Market Profile PCConsole榜单页
   */
  marketProfileCombine: {
    pageId: '910021',
    pageName: 'marketProfilePCConsoleGames',
    pagePath: 'marketProfile/PCConsoleGames',
    typeId: typeIdObj.intelligence,
  },
  marketProfilePC: {
    pageId: '91002',
    pageName: 'marketProfilePCGames',
    pagePath: 'marketProfile/PCGames',
    typeId: typeIdObj.intelligence,
  },
  marketProfileConsole: {
    pageId: '91003',
    pageName: 'marketProfileConsoleGames',
    pagePath: 'marketProfile/ConsoleGames',
    typeId: typeIdObj.intelligence,
  },
  marketProfileAnnual: {
    pageId: '91004',
    pageName: 'marketProfileAnnualReport',
    pagePath: 'marketProfile/AnnualReport',
    typeId: typeIdObj.intelligence,
  },
  // MarketProfile详情页
  marketProfileOverview: {
    pageId: '91005',
    pageName: 'marketProfileOverview',
    pagePath: 'marketProfile/Overview',
    typeId: typeIdObj.intelligence,
  },
  marketProfileInsights: {
    pageId: '91006',
    pageName: 'marketProfileInsights',
    pagePath: 'marketProfile/Insights',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStats: {
    pageId: '91007',
    pageName: 'marketProfileStats',
    pagePath: 'marketProfile/Stats',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsMobileOperationData: {
    pageId: '91009',
    pageName: 'marketProfileStatsMobileOperationData',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilMobile&segment=mobile&type=operation',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsMobileByGames: {
    pageId: '91010',
    pageName: 'marketProfileStatsMobileByGames',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilMobile&segment=mobile&type=game',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsMobileByGenres: {
    pageId: '91011',
    pageName: 'marketProfileStatsMobileByGenres',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilMobile&segment=mobile&type=genre',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsMobileByCompanies: {
    pageId: '91012',
    pageName: 'marketProfileStatsMobileByCompanies',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilMobile&segment=mobile&type=company',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsPCOperationData: {
    pageId: '91013',
    pageName: 'marketProfileStatsPCOperationData',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilPC&segment=mobile&type=operation',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsPCByGames: {
    pageId: '91014',
    pageName: 'marketProfileStatsPCByGames',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilPC&segment=mobile&type=game',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsPCByGenres: {
    pageId: '91015',
    pageName: 'marketProfileStatsPCByGenres',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilPC&segment=mobile&type=genre',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsPCByCompanies: {
    pageId: '91016',
    pageName: 'marketProfileStatsPCByCompanies',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilPC&segment=mobile&type=company',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsConsoleOperationData: {
    pageId: '91017',
    pageName: 'marketProfileStatsConsoleOperationData',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilConsole&segment=mobile&type=operation',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsConsoleByGames: {
    pageId: '91018',
    pageName: 'marketProfileStatsConsoleByGames',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilConsole&segment=mobile&type=game',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsConsoleByGenres: {
    pageId: '91019',
    pageName: 'marketProfileStatsConsoleByGenres',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilConsole&segment=mobile&type=genre',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsConsoleByCompanies: {
    pageId: '91020',
    pageName: 'marketProfileStatsConsoleByCompanies',
    pagePath: 'marketProfile/Stats/detail?pageId=MarketProfilConsole&segment=mobile&type=company',
    typeId: typeIdObj.intelligence,
  },
  marketProfileDemographics: {
    pageId: '91008',
    pageName: 'marketProfileDemographics',
    pagePath: 'marketProfile/Demographics',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsDemographics: {
    pageId: '303201',
    pageName: 'mobileGameDetailsDemographics',
    pagePath: '/TopCharts/MobileGames/GameDetails/Demographics',
    typeId: typeIdObj.intelligence,
  },
  compareMobileActiveUsers: {
    pageId: '302501',
    pageName: 'compareMobileActiveUsers',
    pagePath: '/compare/mobileGames/activeUsers',
    typeId: typeIdObj.intelligence,
  },
  compareMobileRevenue: {
    pageId: '302502',
    pageName: 'compareMobileRevenue',
    pagePath: '/compare/mobileGames/revenue',
    typeId: typeIdObj.intelligence,
  },
  compareMobileDownloads: {
    pageId: '302503',
    pageName: 'compareMobileDownloads',
    pagePath: '/compare/mobileGames/downloads',
    typeId: typeIdObj.intelligence,
  },
  compareMobileStoreRank: {
    pageId: '302504',
    pageName: 'compareMobileStoreRank',
    pagePath: '/compare/mobileGames/storeRank',
    typeId: typeIdObj.intelligence,
  },
  genreProfileMobileGameMainGenre: {
    pageId: '303401',
    pageName: 'genreProfileMobileGamesMainGenre',
    pagePath: '/genreProfile/mobileGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfileMobileGameSubGenre: {
    pageId: '303402',
    pageName: 'genreProfileMobileGamesSubGenre',
    pagePath: '/genreProfile/mobileGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfileMobileGameMainsubGenre: {
    pageId: '303403',
    pageName: 'genreProfileMobileGamesMainsubGenre',
    pagePath: '/genreProfile/mobileGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfilePCGameMainGenre: {
    pageId: '303404',
    pageName: 'genreProfilePcGamesMainGenre',
    pagePath: '/genreProfile/pcGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfilePCGameSubGenre: {
    pageId: '303405',
    pageName: 'genreProfilePcGamesSubGenre',
    pagePath: '/genreProfile/pcGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfilePCGameMainsubGenre: {
    pageId: '303406',
    pageName: 'genreProfilePcGamesMainsubGenre',
    pagePath: '/genreProfile/pcGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfileConsoleGameMainGenre: {
    pageId: '303407',
    pageName: 'genreProfileConsoleGamesMainGenre',
    pagePath: '/genreProfile/consoleGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfileConsoleGameSubGenre: {
    pageId: '303408',
    pageName: 'genreProfileConsoleGamesSubGenre',
    pagePath: '/genreProfile/consoleGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfileConsoleGameMainsubGenre: {
    pageId: '303409',
    pageName: 'genreProfileConsoleGamesMainsubGenre',
    pagePath: '/genreProfile/consoleGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfileTotalGameMainGenre: {
    pageId: '303410',
    pageName: 'genreProfileTotalGameMainGenre',
    pagePath: '/genreProfile/totalGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfileTotalGameSubGenre: {
    pageId: '303411',
    pageName: 'genreProfileTotalGameSubGenre',
    pagePath: '/genreProfile/totalGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfileTotalGameMainsubGenre: {
    pageId: '303412',
    pageName: 'genreProfileTotalGameMainsubGenre',
    pagePath: '/genreProfile/totalGames',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailInsightsMobileGameMarket: {
    pageId: '303413',
    pageName: 'genreProfileDetailInsightsMobileGameMarket',
    pagePath: '/genreProfile/pcGames/detail/insights?entityType=mobile',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailInsightsPCGameMarket: {
    pageId: '303414',
    pageName: 'genreProfileDetailInsightsPCGameMarket',
    pagePath: '/genreProfile/pcGames/detail/insights?entityType=pc',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailInsightsConsoleGameMarket: {
    pageId: '303415',
    pageName: 'genreProfileDetailInsightsConsoleGameMarket',
    pagePath: '/genreProfile/pcGames/detail/insights?entityType=console',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsMobileGameMarketOperationData: {
    pageId: '303421',
    pageName: 'genreProfileDetailStatsMobileGameMarketOperationData',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=mobile',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsMobileGameMarketByGames: {
    pageId: '303422',
    pageName: 'genreProfileDetailStatsMobileGameMarketByGames',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=mobile',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsMobileGameMarketByCountries: {
    pageId: '303423',
    pageName: 'genreProfileDetailStatsMobileGameMarketByCountries',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=mobile',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsMobileGameMarketByCompanies: {
    pageId: '303424',
    pageName: 'genreProfileDetailStatsMobileGameMarketByCompanies',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=mobile',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsPCGameMarketOperationData: {
    pageId: '303425',
    pageName: 'genreProfileDetailStatsPCGameMarketOperationData',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=pc',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsPCGameMarketByGames: {
    pageId: '303426',
    pageName: 'genreProfileDetailStatsPCGameMarketByGames',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=pc',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsPCGameMarketByCountries: {
    pageId: '303427',
    pageName: 'genreProfileDetailStatsPCGameMarketByCountries',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=pc',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsPCGameMarketByCompanies: {
    pageId: '303428',
    pageName: 'genreProfileDetailStatsPCGameMarketByCompanies',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=pc',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsConsoleGameMarketOperationData: {
    pageId: '303429',
    pageName: 'genreProfileDetailStatsConsoleGameMarket',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=console',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsConsoleGameMarketByGames: {
    pageId: '303430',
    pageName: 'genreProfileDetailStatsConsoleGameMarketByGames',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=console',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsConsoleGameMarketByCountries: {
    pageId: '303431',
    pageName: 'genreProfileDetailStatsConsoleGameMarketByCountries',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=console',
    typeId: typeIdObj.intelligence,
  },
  genreProfileDetailStatsConsoleGameMarketByCompanies: {
    pageId: '303432',
    pageName: 'genreProfileDetailStatsConsoleGameMarketByCompanies',
    pagePath: '/genreProfile/pcGames/detail/stats?entityType=console',
    typeId: typeIdObj.intelligence,
  },
  potentialSteamMetrics: {
    pageId: '303301',
    pageName: 'SteamMetrics',
    pagePath: '/potential/steamMetrics',
    typeId: typeIdObj.intelligence,
  },
  // streaming
  streamingInfluencer: {
    pageId: '303501',
    pageName: 'Influencer',
    pagePath: '/streaming/influencer',
    typeId: typeIdObj.intelligence,
  },
  streamingGames: {
    pageId: '303502',
    pageName: 'streamingGames',
    pagePath: '/streaming/games',
    typeId: typeIdObj.intelligence,
  },
  streamingInfluencerTwitch: {
    pageId: '303503',
    pageName: 'streamingInfluencerTwitch',
    pagePath: '/streaming/influencer/details/twitch',
    typeId: typeIdObj.intelligence,
  },
  streamingInfluencerYoutube: {
    pageId: '303504',
    pageName: 'streamingInfluencerYoutube',
    pagePath: '/streaming/influencer/details/ytg',
    typeId: typeIdObj.intelligence,
  },
  streamingInfluencerFacebook: {
    pageId: '303505',
    pageName: 'streamingInfluencerFacebook',
    pagePath: '/streaming/influencer/details/facebook',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCConsoleGamesMetricsTable: {
    pageId: '303601',
    pageName: 'topChartsPCConsoleGamesMetricsTable',
    pagePath: '/TopCharts/PCConsoleGames/MetricsTable',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCConsoleGamesDataBrainCalibration: {
    pageId: '303602',
    pageName: 'topChartsPCConsoleGamesDataBrainCalibration',
    pagePath: '/TopCharts/PCConsoleGames/DataBrainCalibration',
    typeId: typeIdObj.intelligence,
  },
  topChartsPCConsoleGamesAlineaAnalyticsCalibration: {
    pageId: '303603',
    pageName: 'topChartsPCConsoleGamesAlineaAnalyticsCalibration',
    pagePath: '/TopCharts/PCConsoleGames/AlineaAnalyticsCalibration',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsOverview: {
    pageId: '303801',
    pageName: 'topchartsPCConsoleGamesGameDetailsOverview',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Overview',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsKPIOverview: {
    pageId: '303802',
    pageName: 'topchartsPCConsoleGamesGameDetailsKPIOverview',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Overview',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsGameInfo: {
    pageId: '303803',
    pageName: 'topchartsPCConsoleGamesGameDetailsGameInfo',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/gameInfo',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStatsDigitalRevenue: {
    pageId: '303901',
    pageName: 'topchartsPCConsoleGamesGameDetailsStatsDigitalRevenue',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Stats/DigitalRevenue',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStatsPhysicalRevenue: {
    pageId: '303902',
    pageName: 'topchartsPCConsoleGamesGameDetailsStatsPhysicalRevenue',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Stats/PhysicalRevenue',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStatsSteamData: {
    pageId: '303903',
    pageName: 'topchartsPCConsoleGamesGameDetailsStatsSteamData',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Stats/SteamData',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStatsConsoleData: {
    pageId: '303909',
    pageName: 'topchartsPCConsoleGamesGameDetailsStatsConsoleData',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Stats/ConsoleData',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStatsJapanSales: {
    pageId: '303904',
    pageName: 'topchartsPCConsoleGamesGameDetailsStatsJapanSales',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Stats/JapanSales',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStatsNewzooMetrics: {
    pageId: '303905',
    pageName: 'topchartsPCConsoleGamesGameDetailsStatsNewzooMetrics',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Stats/NewzooMetrics',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStatsAllMetrics: {
    pageId: '303906',
    pageName: 'pcConsoleGameDetailsStatsAllMetrics',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Stats/AllMetrics',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStatsGSDSaleData: {
    pageId: '303907',
    pageName: 'topchartsPCConsoleGamesGameDetailsStatsGSDSaleData',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Stats/GSDSaleData',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsKPITrends: {
    pageId: '303908',
    pageName: 'topchartsPCConsoleGamesGameDetailsKPITrends',
    pagePath: '/TopCharts/ConsoleGames/GameDetails/Stats',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsCountriesDigitalRevenue: {
    pageId: '304001',
    pageName: 'topchartsPCConsoleGamesGameDetailsCountriesDigitalRevenue',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Countries/DigitalRevenue',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsCountriesPhysicalRevenue: {
    pageId: '304002',
    pageName: 'topchartsPCConsoleGamesGameDetailsCountriesPhysicalRevenue',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Countries/PhysicalRevenue',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsCountriesJapanSales: {
    pageId: '304003',
    pageName: 'topchartsPCConsoleGamesGameDetailsCountriesJapanSales',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Countries/JapanSales',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsCountriesSteamData: {
    pageId: '304004',
    pageName: 'topchartsPCConsoleGamesGameDetailsCountriesSteamData',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Countries/SteamData',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsCountriesNewzooMetrics: {
    pageId: '304005',
    pageName: 'topchartsPCConsoleGamesGameDetailsCountriesNewzooMetrics',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Countries/NewzooMetrics',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsCountriesGSDSaleData: {
    pageId: '304006',
    pageName: 'topchartsPCConsoleGamesGameDetailsCountriesGSDSaleData',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Countries/GSDSaleData',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsCountriesUserEngagementAmpere: {
    pageId: '304007',
    pageName: 'topchartsPCConsoleGamesGameDetailsCountriesUserEngagementAmpere',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Countries/UserEngagementAmpere',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsCountriesConsoleData: {
    pageId: '304009',
    pageName: 'topchartsPCConsoleGamesGameDetailsCountriesConsoleData',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Countries/ConsoleData',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStoreRank: {
    pageId: '304101',
    pageName: 'topchartsPCConsoleGamesGameDetailsStoreRank',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/storeRank',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStoreRankRankTrend: {
    pageId: '304102',
    pageName: 'topchartsPCConsoleGamesGameDetailsStoreRankRankTrend',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/storeRank',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStoreRankMarketCount: {
    pageId: '304103',
    pageName: 'topchartsPCConsoleGamesGameDetailsStoreRankMarketCount',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/storeRank',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStreamHourwatch: {
    pageId: '304201',
    pageName: 'topchartsPCConsoleGamesGameDetailsStreamingHourswatched',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStreamPeakCCV: {
    pageId: '304202',
    pageName: 'topchartsPCConsoleGamesGameDetailsStreamingPeakCCV',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStreamAvgCCV: {
    pageId: '304203',
    pageName: 'topchartsPCConsoleGamesGameDetailsStreamingAvgCCV',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStreamAirtime: {
    pageId: '304204',
    pageName: 'topchartsPCConsoleGamesGameDetailsStreamingAirtime',
    pagePath: '/TopCharts/PCConsoleGames/GameDetails/Streaming',
    typeId: typeIdObj.intelligence,
  },
  metricsCreditability: {
    pageId: '304301',
    pageName: 'MetricsCreditability',
    pagePath: '/MetricsCreditability',
    typeId: typeIdObj.intelligence,
  },
  overlapAnalysisMobileGame: {
    pageId: '305001',
    pageName: 'overlapAnalysisMobileGame',
    pagePath: '/OverlapAnalysis/MobileGame',
    typeId: typeIdObj.intelligence,
  },
  dataPrivacy: {
    pageId: '305101',
    pageName: 'DataPrivacy',
    pagePath: '/DataPrivacy',
    typeId: typeIdObj.intelligence,
  },
  gameAnalysisReport: {
    pageId: '305201',
    pageName: 'GameAnalysis',
    pagePath: '/reports/GameAnalysis',
    typeId: typeIdObj.intelligence,
  },
  gameResearchReport: {
    pageId: '305202',
    pageName: 'GameResearchReport',
    pagePath: '/gameResearchReport',
    typeId: typeIdObj.intelligence,
  },
  pageIPLibrary: {
    pageId: '306001',
    pageName: 'IPLibrary',
    pagePath: '/IPLibrary',
    typeId: typeIdObj.intelligence,
  },
  pageIpCollaboration: {
    pageId: '306011',
    pageName: 'GameXIpEvaluation',
    pagePath: '/ipCollaboration',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Mini-game Rankings菜单跳转的页面打点配置
   */
  miniGameRankings: {
    pageId: '309902',
    pageName: 'Mini-game Rankings',
    pagePath: '',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Roblox & Fortnite / Roblox Games菜单跳转的页面打点配置
   */
  robloxAndFortnite: {
    pageId: '309901',
    pageName: 'Roblox&Fortnite',
    pagePath: '',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Roblox Game Rank 页面 - 热度 Tab
   */
  casualGamesHubRobloxGameRankPopular: {
    pageId: '309903',
    pageName: 'Roblox Game Rank',
    pagePath: 'casualGamesHub/robloxGameRank',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Roblox Game Rank 页面 - 品类 Tab
   */
  casualGamesHubRobloxGameRankGenres: {
    pageId: '309904',
    pageName: 'Roblox Game Rank',
    pagePath: 'casualGamesHub/robloxGameRank',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Roblox Game Rank 页面 - 变现 Tab
   */
  casualGamesHubRobloxGameRankEarnings: {
    pageId: '309905',
    pageName: 'Roblox Game Rank',
    pagePath: 'casualGamesHub/robloxGameRank',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Roblox Game Rank 页面 - 精选 Tab
   */
  casualGamesHubRobloxGameRankFeatured: {
    pageId: '309906',
    pageName: 'Roblox Game Rank',
    pagePath: 'casualGamesHub/robloxGameRank',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Roblox Top Charts 页面
   */
  casualGamesHubRobloxTopCharts: {
    pageId: '309907',
    pageName: 'Roblox Top Charts',
    pagePath: 'casualGamesHub/robloxTopCharts',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Key Games页面
   */
  casualGamesHubKeyGames: {
    pageId: '309801',
    pageName: 'CasualGamesHubKeyGames',
    pagePath: 'casualGamesHub/keyGames',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Arrows Top Charts页面
   */
  casualGamesHubArrowsTopCharts: {
    pageId: '309822',
    pageName: 'CasualGamesHubArrowsTopCharts',
    pagePath: 'casualGamesHub/arrowsTopCharts',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Narrative Merge-2 Top Charts 页面
   */
  casualGamesHubNarrativeMerge2TopCharts: {
    pageId: '309901',
    pageName: 'CasualGamesHubNarrativeMerge2TopCharts',
    pagePath: 'casualGamesHub/narrativeMerge2TopCharts',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Hyper Casual Top Charts页面 - Casual+Hypercasual Tab
   */
  casualGamesHubCasualHypercasualTopCharts: {
    pageId: '309807',
    pageName: 'CasualGamesHubCasualHypercasualTopCharts',
    pagePath: 'casualGamesHub/hyperCasualTopCharts',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Hyper Casual Top Charts页面 - Hypercasual Tab
   */
  casualGamesHubHyperCasualTopCharts: {
    pageId: '309802',
    pageName: 'CasualGamesHubHyperCasualTopCharts',
    pagePath: 'casualGamesHub/hyperCasualTopCharts',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Hyper Casual Top Charts页面 - IAA Tab
   */
  casualGamesHubHyperCasualTopChartsIAA: {
    pageId: '309808',
    pageName: 'CasualGamesHubHyperCasualTopChartsIAA',
    pagePath: 'casualGamesHub/hyperCasualTopCharts',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (App Magic)页面 - Casual+Hypercasual Tab
   */
  casualGamesHubCasualTopChartsAppMagicCasualHyper: {
    pageId: '309809',
    pageName: 'CasualGamesHubCasualTopChartsAppMagicCasualHyper',
    pagePath: 'casualGamesHub/casualTopChartsAppMagic',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (App Magic)页面 - Hypercasual Tab
   */
  casualGamesHubCasualTopChartsAppMagicHyper: {
    pageId: '309810',
    pageName: 'CasualGamesHubCasualTopChartsAppMagicHyper',
    pagePath: 'casualGamesHub/casualTopChartsAppMagic',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (App Magic)页面 - IAA Tab
   */
  casualGamesHubCasualTopChartsAppMagicIAA: {
    pageId: '309811',
    pageName: 'CasualGamesHubCasualTopChartsAppMagicIAA',
    pagePath: 'casualGamesHub/casualTopChartsAppMagic',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Mahjong Top Charts 页面 - Mahjong App Magic
   */
  casualGamesHubMahjongTopChartsAppMagic: {
    pageId: '309819',
    pageName: 'CasualGamesHubMahjongTopChartsAppMagic',
    pagePath: 'casualGamesHub/CasualTopChartsMahjong',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Mahjong Top Charts 页面 - Mahjong Sensortower
   */
  casualGamesHubMahjongTopChartsSensortower: {
    pageId: '309820',
    pageName: 'CasualGamesHubMahjongTopChartsSensortower',
    pagePath: 'casualGamesHub/CasualTopChartsMahjong',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (SensorTower)页面 - Casual+Hypercasual Tab
   */
  casualGamesHubCasualTopChartsSTCasual: {
    pageId: '309812',
    pageName: 'CasualGamesHubCasualTopChartsSTCasual',
    pagePath: 'casualGamesHub/casualTopChartsST',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (SensorTower)页面 - Hypercasual Tab
   */
  casualGamesHubCasualTopChartsSTHyper: {
    pageId: '309813',
    pageName: 'CasualGamesHubCasualTopChartsSTHyper',
    pagePath: 'casualGamesHub/casualTopChartsST',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (SensorTower)页面 - IAA Tab
   */
  casualGamesHubCasualTopChartsSTIAA: {
    pageId: '309814',
    pageName: 'CasualGamesHubCasualTopChartsSTIAA',
    pagePath: 'casualGamesHub/casualTopChartsST',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Store Ranks页面 - All Top Charts Tab
   */
  casualGamesHubStoreRanksAllTopCharts: {
    pageId: '309815',
    pageName: 'CasualGamesHubStoreRanksAllTopCharts',
    pagePath: 'casualGamesHub/casualGamesStoreRanks',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Store Ranks页面 - Global Compare Tab
   */
  casualGamesHubStoreRanksGlobalCompare: {
    pageId: '309816',
    pageName: 'CasualGamesHubStoreRanksGlobalCompare',
    pagePath: 'casualGamesHub/casualGamesStoreRanks',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Mini-game Rankings页面 - WeChat Games
   */
  casualGamesHubMiniGameRankings: {
    pageId: '309818',
    pageName: 'CasualGamesHubMiniGameRankings',
    pagePath: 'casualGamesHub/casualMiniGameRankings',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Mini-game Rankings页面 - Douyin Games
   */
  casualGamesHubMiniGameRankingsDouyin: {
    pageId: '309821',
    pageName: 'CasualGamesHubMiniGameRankingsDouyin',
    pagePath: 'casualGamesHub/casualMiniGameRankings',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Games Overlap页面
   */
  casualGamesHubGamesOverlap: {
    pageId: '309803',
    pageName: 'CasualGamesHubGamesOverlap',
    pagePath: 'casualGamesHub/gamesOverlap',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Genre Analysis页面
   */
  casualGamesGenreAnalysis: {
    pageId: '309804',
    pageName: 'CasualGamesGenreAnalysis',
    pagePath: 'casualGamesHub/genreAnalysis',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Genre Profile页面
   */
  casualGenreProfile: {
    pageId: '309899',
    pageName: 'CasualGenreProfile',
    pagePath: 'casualGamesHub/casualGenreProfile',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Reports / Market Reports页面
   */
  casualGamesReportsMarketReports: {
    pageId: '309805',
    pageName: 'CasualGamesReportsMarketReports',
    pagePath: 'casualGamesHub/reports/marketReports',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / IAA Benchmarks页面
   */
  iaaBenchmarks: {
    pageId: '309817',
    pageName: 'CasualGamesIAABenchmarks',
    pagePath: 'casualGamesHub/IAABenchmarks',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Reports / Analysis Reports页面
   */
  casualGamesReportsAnalysisReports: {
    pageId: '309806',
    pageName: 'CasualGamesReportsAnalysisReports',
    pagePath: 'casualGamesHub/reports/analysisReports',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Daily Reports
   */
  casualGamesHubDailyReports: {
    pageId: '309807',
    pageName: 'CasualGamesHubDailyReports',
    pagePath: 'casualGamesHub/dailyReports',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Daily Reports页面
   */
  casualDailyReports: {
    pageId: '308802',
    pageName: 'CasualDailyReports',
    pagePath: 'casualDailyReports',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Global Gaming Dynamics 全球游戏动态日报页面
   */
  globalGamingDynamics: {
    pageId: '308804',
    pageName: 'GlobalGamingDynamics',
    pagePath: 'aiDailyNews/globalGamingDynamics',
    typeId: typeIdObj.intelligence,
  },
  /**
   * 情报-鉴权报表页面（authPath/report/:reportId，例如 worldmonitor.app）
   * 通过 uidType + uid 区分具体报表
   */
  intelligenceAuthPathReport: {
    pageId: '308805',
    pageName: 'ComplianceOnGame',
    pagePath: 'authPath/report',
    typeId: typeIdObj.intelligence,
  },
} as any;

/** 按钮打点 */
export const dbiBtnLogMes = {
  /** 首次进入 表格提示信息*/
  topchartMobileGameActiveUserTableTip: {
    pageId: '300101',
    buttonId: '300101001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  /** 首次进入下载提示展示关闭按钮 */
  topchartMobileGameActiveUserDownLoadTip: {
    pageId: '300101',
    buttonId: '300101002',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  // Top Charts / Active Users榜单页下载
  topchartMobileGameActiveUserDownLoadClick: {
    pageId: '300101',
    buttonId: '300101003',
    extInfo: 'Top Charts / Active Users榜单页下载',
    typeId: typeIdObj.intelligence,
  },
  // Top Charts / Revenue榜单页下载
  topchartsMobileGamesRevenueDownloadClick: {
    pageId: '300102',
    buttonId: '300102001',
    extInfo: 'Top Charts / Revenue榜单页下载',
    typeId: typeIdObj.intelligence,
  },
  // Top Charts / Downloads榜单页下载
  topchartsMobileGamesDownloadsDownloadClick: {
    pageId: '300103',
    buttonId: '300103001',
    extInfo: 'Top Charts / Downloads榜单页下载',
    typeId: typeIdObj.intelligence,
  },
  // Top Charts / DataBrain Calibration榜单页下载
  topchartsMobileGamesDataBrainCalibrationDownloadClick: {
    pageId: '300104',
    buttonId: '300104002',
    extInfo: 'Top Charts / DataBrain Calibration榜单页下载',
    typeId: typeIdObj.intelligence,
  },

  // PC Console Compare PCU 下载Excel、CSV
  comparePCConsoleGamesPCUDownloadExcel: {
    pageId: '300401',
    buttonId: '30040101',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  // PC Console Compare MAU 下载Excel、CSV
  comparePCConsoleGamesMAUDownloadExcel: {
    pageId: '300402',
    buttonId: '30040201',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  // PC Console Compare Digital Revenue 下载Excel、CSV
  comparePCConsoleGamesDigitalRevenueDownloadExcel: {
    pageId: '300403',
    buttonId: '30040301',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  // PC Console Compare Physical Revenue 下载Excel、CSV
  comparePCConsoleGamesPhysicalRevenueDownloadExcel: {
    pageId: '300404',
    buttonId: '30040401',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStoreRankDownloadEChart: {
    pageId: '300801',
    buttonId: '300801001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStoreRankDownloadExcel: {
    pageId: '300801',
    buttonId: '300801002',
    extInfo: 'Top Charts-Mobile Games-Store Rank-Market Count',
    typeId: typeIdObj.intelligence,
  },
  pcGameDetailsStoreRankDownloadExcel: {
    pageId: '300802',
    buttonId: '300802002',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  consoleGameDetailsStoreRankDownloadExcel: {
    pageId: '300803',
    buttonId: '300803002',
    extInfo: 'Top Charts-Console Games-Store Rank',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsStoreRankRankTrendDownloadEChart: {
    pageId: '300808',
    buttonId: '300808001',
    extInfo: 'Top Charts-Mobile Games-Store Rank-Rank Trend',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopGenrePerMarketTotalMarketDownload: {
    pageId: '301601',
    buttonId: '301601001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopGenrePerMarketMobileGamesDownload: {
    pageId: '301602',
    buttonId: '301602001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopGenrePerMarketPCGamesDownload: {
    pageId: '301603',
    buttonId: '301603001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopGenrePerMarketConsoleGamesDownload: {
    pageId: '301604',
    buttonId: '301604001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopMarketPerGenreTotalMarketDownload: {
    pageId: '301605',
    buttonId: '301605001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopMarketPerGenreMobileGamesDownload: {
    pageId: '301606',
    buttonId: '301606001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopMarketPerGenrePCGamesDownload: {
    pageId: '301607',
    buttonId: '301607001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  globalViewTopMarketPerGenreConsoleGamesDownload: {
    pageId: '301608',
    buttonId: '301608001',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  topchartsCompanyRevenueDownloadExcel: {
    pageId: '301401',
    buttonId: '30140101',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  topchartsCompanyDownloadsDownloadExcel: {
    pageId: '301402',
    buttonId: '30140201',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  topchartsCompanyMentionsDownloadExcel: {
    pageId: '301403',
    buttonId: '30140301',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankTopDownloadExcel: {
    pageId: '302302',
    buttonId: '30230201',
    extInfo: 'Store Ranks-Mobile Global/Region-主页',
    typeId: typeIdObj.intelligence,
  },
  pcSteamStoreRankTopDownloadExcel: {
    pageId: '302330',
    buttonId: '30233001',
    extInfo: 'Store Ranks-PC Global-Steam-主页',
    typeId: typeIdObj.intelligence,
  },
  pcEpicStoreRankTopDownloadExcel: {
    pageId: '302331',
    buttonId: '30233101',
    extInfo: 'Store Ranks-PC Global-Epic-主页',
    typeId: typeIdObj.intelligence,
  },
  consolePsStoreRankTopDownloadExcel: {
    pageId: '302360',
    buttonId: '30236001',
    extInfo: 'Store Ranks-Console-PlayStation-主页',
    typeId: typeIdObj.intelligence,
  },
  consoleXboxStoreRankTopDownloadExcel: {
    pageId: '302361',
    buttonId: '30236101',
    extInfo: 'Store Ranks-Console-Xbox-主页',
    typeId: typeIdObj.intelligence,
  },
  consoleNintendoStoreRankTopDownloadExcel: {
    pageId: '302362',
    buttonId: '30236201',
    extInfo: 'Store Ranks-Console-Nintendo-主页',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreAppstoreTopFreeDownloadExcel: {
    pageId: '302310',
    buttonId: '30231001',
    extInfo: 'Store Ranks-Mobile Global/Region-下钻页-AppstoreTopFree',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreAppstoreTopGrossingDownloadExcel: {
    pageId: '302311',
    buttonId: '30231101',
    extInfo: 'Store Ranks-Mobile Global/Region-下钻页-AppstoreTopGrossing',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreAppstoreTopPaidDownloadExcel: {
    pageId: '302312',
    buttonId: '30231201',
    extInfo: 'Store Ranks-Mobile Global/Region-下钻页-AppstoreTopPaid',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopFreeDownloadExcel: {
    pageId: '302313',
    buttonId: '30231301',
    extInfo: 'Store Ranks-Mobile Global/Region-下钻页-GoogleplayTopFree',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopGrossingDownloadExcel: {
    pageId: '302314',
    buttonId: '30231401',
    extInfo: 'Store Ranks-Mobile Global/Region-下钻页-GoogleplayTopGrossing',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopPaidDownloadExcel: {
    pageId: '302315',
    buttonId: '30231501',
    extInfo: 'Store Ranks-Mobile Global/Region-下钻页-GoogleplayTopPaid',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopPopularDownloadExcel: {
    pageId: '302316',
    buttonId: '30231601',
    extInfo: 'Store Ranks-Mobile Global/Region-下钻页-GoogleplayTopPopular',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopNewFreeDownloadExcel: {
    pageId: '302317',
    buttonId: '30231701',
    extInfo: 'Store Ranks-Mobile Global/Region-下钻页-GoogleplayTopNewFree',
    typeId: typeIdObj.intelligence,
  },
  mobileStoreRankMoreGoogleplayTopNewPaidDownloadExcel: {
    pageId: '302318',
    buttonId: '30231801',
    extInfo: 'Store Ranks-Mobile Global/Region-下钻页-GoogleplayTopNewPaid',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreSteamTopSellersDownloadExcel: {
    pageId: '302340',
    buttonId: '30234001',
    extInfo: 'Store Ranks-PC Global-Steam-下钻页-TopSellers',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreSteamMostPlayedDownloadExcel: {
    pageId: '302341',
    buttonId: '30234101',
    extInfo: 'Store Ranks-PC Global-Steam-下钻页-MostPlayed',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreSteamNewAndTrendingDownloadExcel: {
    pageId: '302342',
    buttonId: '30234201',
    extInfo: 'Store Ranks-PC Global-Steam-下钻页-NewAndTrending',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreSteamTopWishListsDownloadExcel: {
    pageId: '302343',
    buttonId: '30234301',
    extInfo: 'Store Ranks-PC Global-Steam-下钻页-TopWishLists',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreEpicTopSellersDownloadExcel: {
    pageId: '302344',
    buttonId: '30234401',
    extInfo: 'Store Ranks-PC Global-Epic-下钻页-TopSellers',
    typeId: typeIdObj.intelligence,
  },
  pcStoreRankMoreEpicTopPopularDownloadExcel: {
    pageId: '302345',
    buttonId: '30234501',
    extInfo: 'Store Ranks-PC Global-Epic-下钻页-TopPopular',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationBestSellingDownloadExcel: {
    pageId: '302370',
    buttonId: '30237001',
    extInfo: 'Store Ranks-Console-PlayStation-下钻页-BestSelling',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationMostDownloadedDownloadExcel: {
    pageId: '302371',
    buttonId: '30237101',
    extInfo: 'Store Ranks-Console-PlayStation-下钻页-MostDownloaded',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationNewGamesDownloadExcel: {
    pageId: '302372',
    buttonId: '30237201',
    extInfo: 'Store Ranks-Console-PlayStation-下钻页-NewGames',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationComingSoonDownloadExcel: {
    pageId: '302373',
    buttonId: '30237301',
    extInfo: 'Store Ranks-Console-PlayStation-下钻页-ComingSoon',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationIndiesGamesDownloadExcel: {
    pageId: '302374',
    buttonId: '30237401',
    extInfo: 'Store Ranks-Console-PlayStation-下钻页-IndiesGames',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationFreeToPlayDownloadExcel: {
    pageId: '302375',
    buttonId: '30237501',
    extInfo: 'Store Ranks-Console-PlayStation-下钻页-FreeToPlay',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationPS5MostDownloadedDownloadExcel: {
    pageId: '302376',
    buttonId: '30237601',
    extInfo: 'Store Ranks-Console-PlayStation-下钻页-PS5MostDownloaded',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationPS4MostDownloadedDownloadExcel: {
    pageId: '302377',
    buttonId: '30237701',
    extInfo: 'Store Ranks-Console-PlayStation-下钻页-PS4MostDownloaded',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMorePlaystationVRGamesDownloadExcel: {
    pageId: '302378',
    buttonId: '30237801',
    extInfo: 'Store Ranks-Console-PlayStation-下钻页-VRGames',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxNewReleaseDownloadExcel: {
    pageId: '302379',
    buttonId: '30237901',
    extInfo: 'Store Ranks-Console-Xbox-下钻页-NewRelease',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxUpcomingDownloadExcel: {
    pageId: '302380',
    buttonId: '30238001',
    extInfo: 'Store Ranks-Console-Xbox-下钻页-Upcoming',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxMostPlayedDownloadExcel: {
    pageId: '302381',
    buttonId: '30238101',
    extInfo: 'Store Ranks-Console-Xbox-下钻页-MostPlayed',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreNintendoBestSellersDownloadExcel: {
    pageId: '302382',
    buttonId: '30238201',
    extInfo: 'Store Ranks-Console-Nintendo-下钻页-BestSellers',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreNintendoNewReleaseDownloadExcel: {
    pageId: '302383',
    buttonId: '30238301',
    extInfo: 'Store Ranks-Console-Nintendo-下钻页-NewRelease',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreNintendoComingSoonDownloadExcel: {
    pageId: '302384',
    buttonId: '30238401',
    extInfo: 'Store Ranks-Console-Nintendo-下钻页-ComingSoon',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxBestRatedDownloadExcel: {
    pageId: '302385',
    buttonId: '30238501',
    extInfo: 'Store Ranks-Console-Xbox-下钻页-BestRated',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxTopFreeDownloadExcel: {
    pageId: '302386',
    buttonId: '30238601',
    extInfo: 'Store Ranks-Console-Xbox-下钻页-TopFree',
    typeId: typeIdObj.intelligence,
  },
  consoleStoreRankMoreXboxTopPaidDownloadExcel: {
    pageId: '302387',
    buttonId: '30238701',
    extInfo: 'Store Ranks-Console-Xbox-下钻页-TopPaid',
    typeId: typeIdObj.intelligence,
  },
  followingGamesManageButton: {
    pageId: '302401',
    buttonId: '30240101',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  mobileGameBenchmarkSetting: {
    pageId: '303701',
    buttonId: '30370101',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  mobileGameBenchmarkStatsConfirm: {
    pageId: '303701',
    buttonId: '30370102',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  mobileGameBenchmarkStatsReset: {
    pageId: '303701',
    buttonId: '30370103',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  mobileGameBenchmarkCustomizeConfirm: {
    pageId: '303701',
    buttonId: '30370104',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  mobileGameBenchmarkCustomizeCancel: {
    pageId: '303701',
    buttonId: '30370105',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  mobileGameBenchmarkDownloadExcel: {
    pageId: '303701',
    buttonId: '30370107',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  pcConsoleBenchmarkSetting: {
    pageId: '302601',
    buttonId: '30260101',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  pcConsoleBenchmarkUSDigitalConfirm: {
    pageId: '302601',
    buttonId: '30260102',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  pcConsoleBenchmarkUSDigitalReset: {
    pageId: '302601',
    buttonId: '30260103',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  pcConsoleBenchmarkCustomizeConfirm: {
    pageId: '302601',
    buttonId: '30260104',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  pcConsoleBenchmarkCustomizeCancel: {
    pageId: '302601',
    buttonId: '30260105',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  pcConsoleBenchmarkDownloadExcel: {
    pageId: '302601',
    buttonId: '30260106',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },

  genreProfileDownloadExcel: {
    pageId: '303401',
    buttonId: '30270101',
    extInfo: 'Genre Profile-Mobile Games-MainGenre',
    typeId: typeIdObj.intelligence,
  },

  genreProfileDetailStatsDownloadExcel: {
    pageId: '303421',
    buttonId: '30342101',
    extInfo: 'Genre Profile-Stats-Mobile Games-Operation Data',
    typeId: typeIdObj.intelligence,
  },

  // marketProfile
  marketProfileMobileClickMarket: {
    pageId: '91001',
    buttonId: '9100101',
    extInfo: '跳转详情',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Market Profile PCConsole榜单页指标筛选条件跳转
   */
  marketProfileCombineMetricSelectJump: {
    pageId: '910021',
    buttonId: '91002101',
    extInfo: 'Market Profile PCConsole榜单页指标筛选条件跳转',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Market Profile PCConsole榜单页下载
   */
  marketProfileCombineDownloadExcel: {
    pageId: '910021',
    buttonId: '91002102',
    extInfo: '下载',
    typeId: typeIdObj.intelligence,
  },
  marketProfilePCClickMarket: {
    pageId: '91002',
    buttonId: '9100201',
    extInfo: '跳转详情',
    typeId: typeIdObj.intelligence,
  },
  marketProfileConsoleClickMarket: {
    pageId: '91003',
    buttonId: '9100301',
    extInfo: '跳转详情',
    typeId: typeIdObj.intelligence,
  },
  marketProfileAnnualClickMarket: {
    pageId: '91004',
    buttonId: '9100401',
    extInfo: '跳转详情',
    typeId: typeIdObj.intelligence,
  },
  marketProfileOverviewClickStoreRank: {
    pageId: '91005',
    buttonId: '9100501',
    extInfo: '跳转StoreRank板块',
    typeId: typeIdObj.intelligence,
  },
  marketProfileOverviewClickGame: {
    pageId: '91005',
    buttonId: '9100502',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  marketProfileOverviewClickCompany: {
    pageId: '91005',
    buttonId: '9100503',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  marketProfileInsightsNewRelease: {
    pageId: '91006',
    buttonId: '9100601',
    extInfo: 'New Release',
    typeId: typeIdObj.intelligence,
  },
  marketProfileInsightsUpcoming: {
    pageId: '91006',
    buttonId: '9100602',
    extInfo: 'Upcoming',
    typeId: typeIdObj.intelligence,
  },
  marketProfileMobileInsightsRevGame: {
    pageId: '91006',
    buttonId: '9100604',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  marketProfileInsightsClickGame: {
    pageId: '91006',
    buttonId: '9100605',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  marketProfileInsightsClickCompany: {
    pageId: '91006',
    buttonId: '9100606',
    extInfo: '',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsClickGame: {
    pageId: '91007',
    buttonId: '9100701',
    extInfo: '跳转游戏详情页',
    typeId: typeIdObj.intelligence,
  },
  marketProfileStatsClickCompany: {
    pageId: '91007',
    buttonId: '9100703',
    extInfo: '跳转公司详情页',
    typeId: typeIdObj.intelligence,
  },
  topChartsConsoleGamesJapanSalesDownloadExcel: {
    pageId: '301304',
    buttonId: '30130401',
    extInfo: 'console japan sales榜单 下载',
    typeId: typeIdObj.intelligence,
  },
  // Report Search 搜索关键词埋点
  reportSearchSearch: {
    pageId: '302912',
    buttonId: '302912001',
    extInfo: 'reportSearch搜索关键词',
    typeId: typeIdObj.intelligence,
  },
  aiHubReportsLike: {
    pageId: '302901',
    buttonId: '302901005',
    extInfo: 'aiHubReports点赞',
    typeId: typeIdObj.intelligence,
  },
  aiHubReportsShare: {
    pageId: '302901',
    buttonId: '302901002',
    extInfo: 'aiHubReports分享',
    typeId: typeIdObj.intelligence,
  },
  aiHubReportsDownload: {
    pageId: '302901',
    buttonId: '302901003',
    extInfo: 'aiHubReports下载',
    typeId: typeIdObj.intelligence,
  },
  aiHubReportsDetail: {
    pageId: '302901',
    buttonId: '302901004',
    extInfo: 'aiHubReports查看PDF',
    typeId: typeIdObj.intelligence,
  },
  insightsReportsLike: {
    pageId: '302801',
    buttonId: '302801001',
    extInfo: 'insightsReports点赞',
    typeId: typeIdObj.intelligence,
  },
  insightsReportsShare: {
    pageId: '302801',
    buttonId: '302801002',
    extInfo: 'insightsReports分享',
    typeId: typeIdObj.intelligence,
  },
  insightsReportsDownload: {
    pageId: '302801',
    buttonId: '302801003',
    extInfo: 'insightsReportsDownload',
    typeId: typeIdObj.intelligence,
  },
  insightsReportsDetail: {
    pageId: '302801',
    buttonId: '302801004',
    extInfo: 'insightsReports查看PDF',
    typeId: typeIdObj.intelligence,
  },
  insightsCenterLibraryLike: {
    pageId: '302811',
    buttonId: '302811001',
    extInfo: 'insightsCenterLibrary点赞',
    typeId: typeIdObj.intelligence,
  },
  insightsCenterLibraryShare: {
    pageId: '30281',
    buttonId: '302811002',
    extInfo: 'insightsCenterLibrary分享',
    typeId: typeIdObj.intelligence,
  },
  insightsCenterLibraryDownload: {
    pageId: '302811',
    buttonId: '302811003',
    extInfo: 'insightsCenterLibraryDownload',
    typeId: typeIdObj.intelligence,
  },
  insightsCenterLibraryDetail: {
    pageId: '302811',
    buttonId: '302811004',
    extInfo: 'insightsCenterLibrary查看PDF',
    typeId: typeIdObj.intelligence,
  },
  iMurReportsUrl: {
    pageId: '302902',
    buttonId: '302902001',
    extInfo: '跳转到report详情',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsDetail: {
    pageId: '303001',
    buttonId: '303001001',
    extInfo: 'MarketReports查看PDF',
    typeId: typeIdObj.intelligence,
  },
  MarketReportsDownload: {
    pageId: '303001',
    buttonId: '303001002',
    extInfo: 'MarketReports下载PDF',
    typeId: typeIdObj.intelligence,
  },
  mobileDeviceReportsDetail: {
    pageId: '302702',
    buttonId: '302702001',
    extInfo: 'mobileDeviceReports查看PDF',
    typeId: typeIdObj.intelligence,
  },
  mobileDeviceReportsDownload: {
    pageId: '302702',
    buttonId: '302702002',
    extInfo: 'mobileDeviceReports下载PDF',
    typeId: typeIdObj.intelligence,
  },
  streamingGamesDownloadExcel: {
    pageId: '303502',
    buttonId: '30350201',
    extInfo: 'Streaming Games榜单页 下载EXCEL、CSV',
    typeId: typeIdObj.intelligence,
  },
  streamingInfluencerTwitchDownloadExcel: {
    pageId: '303503',
    buttonId: '30350301',
    extInfo: 'Streaming influencer下钻页 Twitch 下载EXCEL、CSV',
    typeId: typeIdObj.intelligence,
  },
  streamingInfluencerYoutubeDownloadExcel: {
    pageId: '303504',
    buttonId: '30350401',
    extInfo: 'Streaming influencer下钻页 Youtube 下载EXCEL、CSV',
    typeId: typeIdObj.intelligence,
  },
  streamingInfluencerFacebookDownloadExcel: {
    pageId: '303505',
    buttonId: '30350501',
    extInfo: 'Streaming influencer下钻页 Facebook 下载EXCEL、CSV',
    typeId: typeIdObj.intelligence,
  },
  pcConsoleGameDetailsStoreRankDownloadExcel: {
    pageId: '304101',
    buttonId: '30410101',
    extInfo: 'PC Console详情页Store Rank下载',
    typeId: typeIdObj.intelligence,
  },
  mobileGameDetailsOverlapDownloadExcel: {
    pageId: '300905',
    buttonId: '30090501',
    extInfo: 'Mobile详情页 Overlap页签 下载EXCEL、CSV',
    typeId: typeIdObj.intelligence,
  },
  gameAnalysisLike: {
    pageId: '305201',
    buttonId: '305201001',
    extInfo: 'gameAnalysis report点赞',
    typeId: typeIdObj.intelligence,
  },
  gameAnalysisShare: {
    pageId: '305201',
    buttonId: '305201002',
    extInfo: 'gameAnalysis report分享',
    typeId: typeIdObj.intelligence,
  },
  gameAnalysisDownload: {
    pageId: '305201',
    buttonId: '305201003',
    extInfo: 'gameAnalysisDownload',
    typeId: typeIdObj.intelligence,
  },
  gameAnalysisReportsDetail: {
    pageId: '305201',
    buttonId: '305201005',
    extInfo: 'gameAnalysisReports查看PDF',
    typeId: typeIdObj.intelligence,
  },
  gameResearchLike: {
    pageId: '305202',
    buttonId: '305202001',
    extInfo: 'gameResearch report点赞',
    typeId: typeIdObj.intelligence,
  },
  gameResearchShare: {
    pageId: '305202',
    buttonId: '305202002',
    extInfo: 'gameResearch report分享',
    typeId: typeIdObj.intelligence,
  },
  gameResearchDownload: {
    pageId: '305202',
    buttonId: '305202003',
    extInfo: 'gameResearchDownload',
    typeId: typeIdObj.intelligence,
  },
  gameResearchReportsDetail: {
    pageId: '305202',
    buttonId: '305202005',
    extInfo: 'gameResearch查看PDF',
    typeId: typeIdObj.intelligence,
  },
  // 真数下载打点
  trueAllDataDownloadExcel: {
    pageId: '100102',
    buttonId: '305203001',
    extInfo: '真数下载打点',
    typeId: typeIdObj.intelligence,
  },
  // 首页真数模块真数上传按钮打点
  homeTrueAllDataReport: {
    pageId: '305203',
    buttonId: '305203901',
    extInfo: '首页真数模块真数上传按钮打点',
    typeId: typeIdObj.intelligence,
  },
  // 情报combine游戏详情页头部真数上传按钮打点
  gameDetailsHeaderTrueAllDataReport: {
    pageId: '305203',
    buttonId: '305203902',
    extInfo: '情报combine游戏详情页头部真数上传按钮打点',
    typeId: typeIdObj.intelligence,
  },
  // 游戏详情页Overview页签真数模块上传按钮打点
  gameDetailsOverviewTrueAllDataReport: {
    pageId: '305203',
    buttonId: '305203903',
    extInfo: '游戏详情页Overview页签真数模块上传按钮打点',
    typeId: typeIdObj.intelligence,
  },
  // 游戏详情页KPI Overview页签真数模块上传按钮打点
  gameDetailsKPIOverviewTrueAllDataReport: {
    pageId: '305203',
    buttonId: '305203904',
    extInfo: '游戏详情页KPI Overview页签真数模块上传按钮打点',
    typeId: typeIdObj.intelligence,
  },
  visualMetricSelectorDual: {
    pageId: '303908',
    buttonId: '303908017',
    typeId: typeIdObj.intelligence,
    componentName: 'Visualization',
  },
  metricHoverExplinationClick: {
    pageId: '303908',
    buttonId: '303908018',
    typeId: typeIdObj.intelligence,
    componentName: 'Click',
  },
  // combine详情页点击Calibration Metrics Switcher按钮查看Databrain数据校准指标数据
  calibrationMetricsSwitcherClick: {
    pageId: '303908',
    buttonId: '303908019',
    typeId: typeIdObj.intelligence,
    extInfo: '',
  },
  // combine详情页点击Show All True Data按钮查看真数弹窗
  showAllTrueDataClick: {
    pageId: '303908',
    buttonId: '303908020',
    typeId: typeIdObj.intelligence,
    extInfo: '',
  },
  trueDataAlineaTabClick: {
    pageId: '303908',
    buttonId: '303908022',
    typeId: typeIdObj.intelligence,
    extInfo: '',
  },
  trueDataDownloadClick: {
    pageId: '303908',
    buttonId: '303908023',
    typeId: typeIdObj.intelligence,
    extInfo: '',
  },
  dataBrainCardClick: {
    pageId: '300104',
    buttonId: '300104001',
    typeId: typeIdObj.intelligence,
    componentName: 'DataBrain Card Click',
  },
  // KPI Overview Steam Hourly CCU 下钻至 KPI Trends Hour tab
  steamHourlyCcuDrillDown: {
    pageId: '303802',
    buttonId: '303802001',
    typeId: typeIdObj.intelligence,
    extInfo: 'Top Charts-PC And Console Games-KPI Overview-Steam Hourly CCU Drill Down',
  },
  // KPI Trends Hour tab
  kpiTrendsHourTabClick: {
    pageId: '303908',
    buttonId: '303908021',
    typeId: typeIdObj.intelligence,
    extInfo: 'Top Charts-PC And Console Games-KPI Trends-Hour Tab Click',
  },
  // 警报提示链接点击埋点 - Intelligence Benchmark Mobile Device Distribution
  dataAlertTipMobileDeviceLink: {
    pageId: '302701',
    buttonId: '302701001',
    extInfo: 'Intelligence_Benchmark - Mobile Device Distribution',
    typeId: typeIdObj.intelligence,
  },
  // mobile overlap 榜单页下载
  topChartOverlapAnalysisMobileGamesDownloadClick: {
    pageId: '300110',
    buttonId: '300110001',
    extInfo: 'Overlap Analysis Mobile Games Download Click',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Key Games页面下载
   */
  casualGamesHubKeyGamesDownloadClick: {
    pageId: '309801',
    buttonId: '309801001',
    extInfo: 'Casual Games Hub / Key Games页面下载',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Arrows Top Charts页面下载
   */
  casualGamesHubArrowsTopChartsDownloadClick: {
    pageId: '309822',
    buttonId: '309822001',
    extInfo: 'Casual Games Hub / Arrows Top Charts页面下载',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Narrative Merge-2 Top Charts 页面下载
   */
  casualGamesHubNarrativeMerge2TopChartsDownloadClick: {
    pageId: '309901',
    buttonId: '309901001',
    extInfo: 'Casual Games Hub / Narrative Merge-2 Top Charts 页面下载',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Hyper Casual Top Charts页面下载 - Casual+Hypercasual Tab
   */
  casualGamesHubCasualHypercasualTopChartsDownloadClick: {
    pageId: '309807',
    buttonId: '309807001',
    extInfo: 'Casual Games Hub / Hyper Casual Top Charts页面下载 - Casual+Hypercasual Tab',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Hyper Casual Top Charts页面下载 - Hypercasual Tab
   */
  casualGamesHubHyperCasualTopChartsDownloadClick: {
    pageId: '309802',
    buttonId: '309802001',
    extInfo: 'Casual Games Hub / Hyper Casual Top Charts页面下载',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Hyper Casual Top Charts页面下载 - IAA Tab
   */
  casualGamesHubHyperCasualTopChartsIAADownloadClick: {
    pageId: '309808',
    buttonId: '309808001',
    extInfo: 'Casual Games Hub / Hyper Casual Top Charts页面下载 - IAA Tab',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (App Magic)页面下载 - Casual+Hypercasual Tab
   */
  casualGamesHubCasualTopChartsAppMagicCasualHyperDownloadClick: {
    pageId: '309809',
    buttonId: '309809001',
    extInfo: 'Casual Games Hub / Casual Top Charts (App Magic)页面下载 - Casual+Hypercasual Tab',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (App Magic)页面下载 - Hypercasual Tab
   */
  casualGamesHubCasualTopChartsAppMagicHyperDownloadClick: {
    pageId: '309810',
    buttonId: '309810001',
    extInfo: 'Casual Games Hub / Casual Top Charts (App Magic)页面下载 - Hypercasual Tab',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (App Magic)页面下载 - IAA Tab
   */
  casualGamesHubCasualTopChartsAppMagicIAADownloadClick: {
    pageId: '309811',
    buttonId: '309811001',
    extInfo: 'Casual Games Hub / Casual Top Charts (App Magic)页面下载 - IAA Tab',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Mahjong Top Charts 页面下载 - App Magic
   */
  casualGamesHubMahjongTopChartsAppMagicDownloadClick: {
    pageId: '309819',
    buttonId: '309819001',
    extInfo: 'Casual Games Hub / Mahjong Top Charts 页面下载 - App Magic',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Mahjong Top Charts 页面下载 - App Magic
   */
  casualGamesHubMahjongTopChartsSensortowerDownloadClick: {
    pageId: '309820',
    buttonId: '309820001',
    extInfo: 'Casual Games Hub / Mahjong Top Charts 页面下载 - Sensortower',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (SensorTower)页面下载 - Casual+Hypercasual Tab
   */
  casualGamesHubCasualTopChartsSTCasualDownloadClick: {
    pageId: '309812',
    buttonId: '309812001',
    extInfo: 'Casual Games Hub / Casual Top Charts (SensorTower)页面下载 - Casual+Hypercasual Tab',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (SensorTower)页面下载 - Hypercasual Tab
   */
  casualGamesHubCasualTopChartsSTHyperDownloadClick: {
    pageId: '309813',
    buttonId: '309813001',
    extInfo: 'Casual Games Hub / Casual Top Charts (SensorTower)页面下载 - Hypercasual Tab',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Casual Top Charts (SensorTower)页面下载 - IAA Tab
   */
  casualGamesHubCasualTopChartsSTIAADownloadClick: {
    pageId: '309814',
    buttonId: '309814001',
    extInfo: 'Casual Games Hub / Casual Top Charts (SensorTower)页面下载 - IAA Tab',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Store Ranks页面下载 - All Top Charts Tab
   */
  casualGamesHubStoreRanksAllTopChartsDownloadClick: {
    pageId: '309815',
    buttonId: '309815001',
    extInfo: 'Casual Games Hub / Store Ranks页面下载 - All Top Charts Tab',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Store Ranks页面下载 - Global Compare Tab
   */
  casualGamesHubStoreRanksGlobalCompareDownloadClick: {
    pageId: '309816',
    buttonId: '309816001',
    extInfo: 'Casual Games Hub / Store Ranks页面下载 - Global Compare Tab',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Mini-game Rankings页面下载 - WeChat Games
   */
  casualGamesHubMiniGameRankingsDownloadClick: {
    pageId: '309818',
    buttonId: '309818001',
    extInfo: 'Casual Games Hub / Mini-game Rankings页面下载 - WeChat Games',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Roblox Game Rank 页面下载
   */
  casualGamesHubRobloxGameRankDownloadClick: {
    pageId: '309903',
    buttonId: '309903001',
    extInfo: 'Casual Games Hub / Roblox Game Rank 页面下载',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Roblox Game Rank 榜单切换
   */
  casualGamesHubRobloxGameRankSourceChange: {
    pageId: '309903',
    buttonId: '309903002',
    buttonName: 'RobloxGameRankSourceChange',
    extInfo: 'Casual Games Hub / Roblox Game Rank 榜单切换',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Roblox Top Charts 页面下载
   */
  casualGamesHubRobloxTopChartsDownloadClick: {
    pageId: '309907',
    buttonId: '309907001',
    extInfo: 'Casual Games Hub / Roblox Top Charts 页面下载',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Games Overlap页面下载
   */
  casualGamesHubGamesOverlapDownloadClick: {
    pageId: '309803',
    buttonId: '309803001',
    extInfo: 'Casual Games Hub / Games Overlap页面下载',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Reports / Market Reports页面下载Excel
   */
  casualGamesReportsMarketReportsDownloadExcel: {
    pageId: '309805',
    buttonId: '309805001',
    extInfo: 'Casual Games Hub / Reports / Market Reports页面下载Excel',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Reports / Analysis Reports页面下载报告
   */
  casualGamesReportsAnalysisReportsDownloadReport: {
    pageId: '309806',
    buttonId: '309806001',
    extInfo: 'Casual Games Hub / Reports / Analysis Reports页面下载报告',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Games Hub / Reports / Analysis Reports页面复制作者邮箱
   */
  casualGamesReportsAnalysisReportsCopyEmail: {
    pageId: '309806',
    buttonId: '309806009',
    extInfo: 'Casual Games Hub / Reports / Analysis Reports页面复制作者邮箱',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Daily Reports页面点击新闻链接
   */
  casualDailyReportsClickNews: {
    pageId: '308802',
    buttonId: '308802001',
    extInfo: 'Casual Daily Reports页面点击新闻链接',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Daily Reports页面点击游戏链接
   */
  casualDailyReportsClickGames: {
    pageId: '308802',
    buttonId: '308802002',
    extInfo: 'Casual Daily Reports页面点击游戏链接',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Daily Reports页面点击下载图片
   */
  casualDailyReportsClickDownload: {
    pageId: '308802',
    buttonId: '308802003',
    extInfo: 'Casual Daily Reports页面下载图片',
    typeId: typeIdObj.intelligence,
  },
  /**
   * Casual Daily Reports页面点击今日核心要点中的GRC敏捷报告跳转链接
   */
  casualDailyReportsClickCorePointsGRCReportLinker: {
    pageId: '308802',
    buttonId: '308802004',
    extInfo: 'Casual Daily Reports页面点击今日核心要点模块的GRC敏捷报告超链接',
    typeId: typeIdObj.intelligence,
  },

  FollowingMobileGamesCurrentGamesDownloadButton: {
    pageId: '302401',
    buttonId: '302401001',
    extInfo: 'Following-Mobile Games-Current Games',
    typeId: typeIdObj.intelligence,
  },
  FollowingMobileGamesNewReleaseAndUpcomingGamesDownloadButton: {
    pageId: '302405',
    buttonId: '302405001',
    extInfo: 'Following-Mobile Games-New Release And Upcoming Games',
    typeId: typeIdObj.intelligence,
  },
  FollowingPCGamesCurrentGamesDownloadButton: {
    pageId: '302402',
    buttonId: '302402001',
    extInfo: 'Following-PC Games-Current Games',
    typeId: typeIdObj.intelligence,
  },
  FollowingPCGamesNewReleaseAndUpcomingGamesDownloadButton: {
    pageId: '302406',
    buttonId: '302406001',
    extInfo: 'Following-PC Games-New Release And Upcoming Games',
    typeId: typeIdObj.intelligence,
  },
  FollowingConsoleGamesCurrentGamesDownloadButton: {
    pageId: '302403',
    buttonId: '302403001',
    extInfo: 'Following-Console Games-Current Games',
    typeId: typeIdObj.intelligence,
  },
  FollowingConsoleGamesNewReleaseAndUpcomingGamesDownloadButton: {
    pageId: '302407',
    buttonId: '302407001',
    extInfo: 'Following-Console Games-New Release And Upcoming Games',
    typeId: typeIdObj.intelligence,
  },
  FollowingCompaniesDownloadButton: {
    pageId: '302404',
    buttonId: '302404001',
    extInfo: 'Following-Companies',
    typeId: typeIdObj.intelligence,
  },

  // Game Comparison Feature - Tab Click
  gameComparisonTabClick: {
    pageId: '300901',
    buttonId: '300901001',
    extInfo: 'Game Details-Game Comparison Tab Click',
    typeId: typeIdObj.intelligence,
  },
  // Game Comparison Feature - VS Button Click
  gameComparisonVSButtonClick: {
    pageId: '300902',
    buttonId: '300902001',
    extInfo: 'Game Details-Competitors VS Button Click',
    typeId: typeIdObj.intelligence,
  },

  TopChartsMobileGamesRPDDownloadButton: {
    pageId: '300105',
    buttonId: '300105001',
    extInfo: 'Top Charts-Mobile Games-RPD',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesRetentionDownloadButton: {
    pageId: '300106',
    buttonId: '300106001',
    extInfo: 'Top Charts-Mobile Games-Retention',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesDemographicsDownloadButton: {
    pageId: '300109',
    buttonId: '300109001',
    extInfo: 'Top Charts-Mobile Games-Demographics',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesNewReleaseDownloadButton: {
    pageId: '300107',
    buttonId: '300107001',
    extInfo: 'Top Charts-Mobile Games-New Release',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesUpcomingDownloadButton: {
    pageId: '300108',
    buttonId: '300108001',
    extInfo: 'Top Charts-Mobile Games-Upcoming',
    typeId: typeIdObj.intelligence,
  },

  TopChartsMobileGamesStatsActiveUsersDownloadButton: {
    pageId: '300601',
    buttonId: '300601001',
    extInfo: 'Top Charts-Mobile Games-Stats-Active Users',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesStatsRevenueDownloadButton: {
    pageId: '300602',
    buttonId: '300602001',
    extInfo: 'Top Charts-Mobile Games-Stats-Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesStatsDownloadsDownloadButton: {
    pageId: '300603',
    buttonId: '300603001',
    extInfo: 'Top Charts-Mobile Games-Stats-Downloads',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesStatsMonthlyRetentionDownloadButton: {
    pageId: '300604',
    buttonId: '300604001',
    extInfo: 'Top Charts-Mobile Games-Stats-MonthlyRetention',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesStatsLifetimeRetentionDownloadButton: {
    pageId: '300605',
    buttonId: '300605001',
    extInfo: 'Top Charts-Mobile Games-Stats-LifetimeRetention',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesStatsRPDDownloadButton: {
    pageId: '300606',
    buttonId: '300606001',
    extInfo: 'Top Charts-Mobile Games-Stats-RPD',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesCountriesActiveUsersDownloadButton: {
    pageId: '300701',
    buttonId: '300701001',
    extInfo: 'Top Charts-Mobile Games-Countries-Active Users',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesCountriesRevenueDownloadButton: {
    pageId: '300702',
    buttonId: '300702001',
    extInfo: 'Top Charts-Mobile Games-Countries-Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesCountriesDownloadsDownloadButton: {
    pageId: '300703',
    buttonId: '300703001',
    extInfo: 'Top Charts-Mobile Games-Countries-Downloads',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesCountriesMonthlyRetentionDownloadButton: {
    pageId: '300704',
    buttonId: '300704001',
    extInfo: 'Top Charts-Mobile Games-Countries-MonthlyRetention',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesCountriesLifetimeRetentionDownloadButton: {
    pageId: '300705',
    buttonId: '300705001',
    extInfo: 'Top Charts-Mobile Games-Countries-LifetimeRetention',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesCountriesRPDDownloadButton: {
    pageId: '300706',
    buttonId: '300706001',
    extInfo: 'Top Charts-Mobile Games-Countries-RPD',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesStoreRankRankTrendDownloadButton: {
    pageId: '300808',
    buttonId: '300808001',
    extInfo: 'Top Charts-Mobile Games-Store Rank-Rank Trend',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesStoreRankMarketCountDownloadButton: {
    pageId: '300801',
    buttonId: '300801001',
    extInfo: 'Top Charts-Mobile Games-Store Rank-Market Count',
    typeId: typeIdObj.intelligence,
  },
  TopChartsMobileGamesDetailDemographicsDownloadButton: {
    pageId: '303201',
    buttonId: '303201001',
    extInfo: 'Top Charts-Mobile Games-Detail-Demographics',
    typeId: typeIdObj.intelligence,
  },

  TopChartsPCAndConsoleGamesGameInfoSteamNewsAndAnnouncementsDownloadButton: {
    pageId: '303803',
    buttonId: '303803001',
    extInfo: 'Top Charts-PC And Console Games-Game Info-Steam News And Announcements',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesKPITrendsDownloadButton: {
    pageId: '303908',
    buttonId: '303908001',
    extInfo: 'Top Charts-PC And Console Games-KPI Trends',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesStatsAllMetricsDownloadButton: {
    pageId: '303906',
    buttonId: '303906001',
    extInfo: 'Top Charts-PC And Console Games-Stats-AllMetrics',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesStatsDigitalRevenueDownloadButton: {
    pageId: '303901',
    buttonId: '303901001',
    extInfo: 'Top Charts-PC And Console Games-Stats-DigitalRevenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesStatsPhysicalRevenueDownloadButton: {
    pageId: '303902',
    buttonId: '303902001',
    extInfo: 'Top Charts-PC And Console Games-Stats-PhysicalRevenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesStatsSteamDataDownloadButton: {
    pageId: '303903',
    buttonId: '303903001',
    extInfo: 'Top Charts-PC And Console Games-Stats-SteamData',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesStatsJapanSalesDownloadButton: {
    pageId: '303904',
    buttonId: '303904001',
    extInfo: 'Top Charts-PC And Console Games-Stats-JapanSales',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesStatsNewzooMetricsDownloadButton: {
    pageId: '303905',
    buttonId: '303905001',
    extInfo: 'Top Charts-PC And Console Games-Stats-NewzooMetrics',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesStatsGSDSaleDataDownloadButton: {
    pageId: '303907',
    buttonId: '303907001',
    extInfo: 'Top Charts-PC And Console Games-Stats-GSDSaleData',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesStoreRankMarketCountDownloadButton: {
    pageId: '304103',
    buttonId: '304103001',
    extInfo: 'Top Charts-PC And Console Games-Store Rank-Market Count',
    typeId: typeIdObj.intelligence,
  },

  TopChartsPCAndConsoleGamesSteamOverlapDownloadButton: {
    pageId: '300907',
    buttonId: '300907001',
    extInfo: 'Top Charts-PC And Console Games-Steam Overlap',
    typeId: typeIdObj.intelligence,
  },

  TopChartsPCGamesPCUDownloadButton: {
    pageId: '301202',
    buttonId: '301202001',
    extInfo: 'Top Charts-PC Games-PCU',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesDigitalRevenueDownloadButton: {
    pageId: '301203',
    buttonId: '301203001',
    extInfo: 'Top Charts-PC Games-Digital Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesPhysicalRevenueDownloadButton: {
    pageId: '301204',
    buttonId: '301204001',
    extInfo: 'Top Charts-PC Games-Physical Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesSteamSalesDownloadButton: {
    pageId: '301205',
    buttonId: '301205001',
    extInfo: 'Top Charts-PC Games-Steam Sales',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesMAUDownloadButton: {
    pageId: '301206',
    buttonId: '301206001',
    extInfo: 'Top Charts-PC Games-MAU',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesLifetimePlayersDownloadButton: {
    pageId: '301207',
    buttonId: '301207001',
    extInfo: 'Top Charts-PC Games-Lifetime Players',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesNewReleaseDownloadButton: {
    pageId: '301208',
    buttonId: '301208001',
    extInfo: 'Top Charts-PC Games-New Release',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesUpcomingDownloadButton: {
    pageId: '301209',
    buttonId: '301209001',
    extInfo: 'Top Charts-PC Games-Upcoming',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesStatsPCUDownloadButton: {
    pageId: '301801',
    buttonId: '301801001',
    extInfo: 'Top Charts-PC Games-Stats-PCU',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesStatsDigitalRevenueDownloadButton: {
    pageId: '301802',
    buttonId: '301802001',
    extInfo: 'Top Charts-PC Games-Stats-Digital Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesStatsGSDSaleDataDownloadButton: {
    pageId: '301806',
    buttonId: '301806001',
    extInfo: 'Top Charts-PC Games-Stats-GSD SaleData',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesStatsPhysicalRevenueDownloadButton: {
    pageId: '301803',
    buttonId: '301803001',
    extInfo: 'Top Charts-PC Games-Stats-Physical Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesStatsSteamSalesDownloadButton: {
    pageId: '301804',
    buttonId: '301804001',
    extInfo: 'Top Charts-PC Games-Stats-Steam Sales',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesStatsNewzooMetricsDownloadButton: {
    pageId: '301805',
    buttonId: '301805001',
    extInfo: 'Top Charts-PC Games-Stats-No Update',
    typeId: typeIdObj.intelligence,
  },

  TopChartsPCGamesCountriesPCUDownloadButton: {
    pageId: '301901',
    buttonId: '301901001',
    extInfo: 'Top Charts-PC Games-Countries-PCU',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesCountriesDigitalRevenueDownloadButton: {
    pageId: '301902',
    buttonId: '301902001',
    extInfo: 'Top Charts-PC Games-Countries-Digital Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesCountriesPhysicalRevenueDownloadButton: {
    pageId: '301903',
    buttonId: '301903001',
    extInfo: 'Top Charts-PC Games-Countries-Physical Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesCountriesGSDSaleDataDownloadButton: {
    pageId: '301906',
    buttonId: '301906001',
    extInfo: 'Top Charts-PC Games-Countries-GSD Sale Data',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesCountriesSteamSalesDownloadButton: {
    pageId: '301904',
    buttonId: '301904001',
    extInfo: 'Top Charts-PC Games-Countries-Steam Sales',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesCountriesNewzooMetricsDownloadButton: {
    pageId: '301905',
    buttonId: '301905001',
    extInfo: 'Top Charts-PC Games-Countries-No Update',
    typeId: typeIdObj.intelligence,
  },

  TopChartsConsoleGamesDigitalRevenueDownloadButton: {
    pageId: '301302',
    buttonId: '301302001',
    extInfo: 'Top Charts-Console Games-Digital Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesPhysicalRevenueDownloadButton: {
    pageId: '301303',
    buttonId: '301303001',
    extInfo: 'Top Charts-Console Games-Physical Revenue',
    typeId: typeIdObj.intelligence,
  },

  TopChartsConsoleGamesMAUDownloadButton: {
    pageId: '301305',
    buttonId: '301305001',
    extInfo: 'Top Charts-Console Games-MAU',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesLifetimePlayersDownloadButton: {
    pageId: '301306',
    buttonId: '301306001',
    extInfo: 'Top Charts-Console Games-Lifetime Players',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesNewReleaseDownloadButton: {
    pageId: '301307',
    buttonId: '301307001',
    extInfo: 'Top Charts-Console Games-New Release',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesUpcomingDownloadButton: {
    pageId: '301308',
    buttonId: '301308001',
    extInfo: 'Top Charts-Console Games-Upcoming',
    typeId: typeIdObj.intelligence,
  },

  TopChartsConsoleGamesCountriesDigitalRevenueDownloadButton: {
    pageId: '302201',
    buttonId: '302201001',
    extInfo: 'Top Charts-Console Games-Countries-Digital Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesCountriesGSDSaleDataDownloadButton: {
    pageId: '302205',
    buttonId: '302205001',
    extInfo: 'Top Charts-Console Games-Countries-GSD Sale Data',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesCountriesPhysicalRevenueDownloadButton: {
    pageId: '302202',
    buttonId: '302202001',
    extInfo: 'Top Charts-Console Games-Countries-Physical Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesCountriesJapanSalesDownloadButton: {
    pageId: '302203',
    buttonId: '302203001',
    extInfo: 'Top Charts-Console Games-Countries-Japan Sales',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesCountriesNewzooMetricsDownloadButton: {
    pageId: '302204',
    buttonId: '302204001',
    extInfo: 'Top Charts-Console Games-Countries-No Update',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesStoreRankDownloadButton: {
    pageId: '300803',
    buttonId: '300803001',
    extInfo: 'Top Charts-Console Games-Store Rank',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCGamesOverlapDownloadButton: {
    pageId: '300906',
    buttonId: '300906001',
    extInfo: 'Top Charts-PC Games-Overlap',
    typeId: typeIdObj.intelligence,
  },

  TopChartsCompaniesGamesAndStatsMobileRevenueDownloadButton: {
    pageId: '301508',
    buttonId: '301508001',
    extInfo: 'Top Charts - Companies-Games And Stats-Mobile Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsCompaniesGamesAndStatsMobileDownloadsDownloadButton: {
    pageId: '301509',
    buttonId: '301509001',
    extInfo: 'Top Charts - Companies-Games And Stats-Mobile Downloads',
    typeId: typeIdObj.intelligence,
  },
  TopChartsCompaniesGamesAndStatsPCDigitalRevenueDownloadButton: {
    pageId: '301510',
    buttonId: '301510001',
    extInfo: 'Top Charts - Companies-Games And Stats-PC Digital Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsCompaniesGamesAndStatsPCPhysicalRevenueDownloadButton: {
    pageId: '301511',
    buttonId: '301511001',
    extInfo: 'Top Charts - Companies-Games And Stats-PC Physical Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsCompaniesGamesAndStatsPCPCUDownloadButton: {
    pageId: '301512',
    buttonId: '301512001',
    extInfo: 'Top Charts - Companies-Games And Stats-PC PCU',
    typeId: typeIdObj.intelligence,
  },
  TopChartsCompaniesGamesAndStatsPCMAUDownloadButton: {
    pageId: '301513',
    buttonId: '301513001',
    extInfo: 'Top Charts - Companies-Games And Stats-PC MAU',
    typeId: typeIdObj.intelligence,
  },
  TopChartsCompaniesGamesAndStatsConsoleDigitalRevenueDownloadButton: {
    pageId: '301514',
    buttonId: '301514001',
    extInfo: 'Top Charts - Companies-Games And Stats-Console Digital Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsCompaniesGamesAndStatsConsolePhysicalRevenueDownloadButton: {
    pageId: '301515',
    buttonId: '301515001',
    extInfo: 'Top Charts - Companies-Games And Stats-Console Physical Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsCompaniesGamesAndStatsConsoleMAUDownloadButton: {
    pageId: '301516',
    buttonId: '301516001',
    extInfo: 'Top Charts - Companies-Games And Stats-Console MAU',
    typeId: typeIdObj.intelligence,
  },
  TopChartsCompaniesGamesAndStatsGamesOwnedDownloadButton: {
    pageId: '301517',
    buttonId: '301517001',
    extInfo: 'Top Charts - Companies-Games And Stats-Games Owned',
    typeId: typeIdObj.intelligence,
  },

  MarketProfileMobileGamesDownloadButton: {
    pageId: '91001',
    buttonId: '91001001',
    extInfo: 'Market Profile-Mobile Games',
    typeId: typeIdObj.intelligence,
  },

  MarketProfilePCGamesDownloadButton: {
    pageId: '91002',
    buttonId: '91002001',
    extInfo: 'Market Profile-PC Games donwnload',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileConsoleGamesDownloadButton: {
    pageId: '91003',
    buttonId: '91003001',
    extInfo: 'Market Profile-Console Games donwnload',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsMobileOperationDataDownloadButton: {
    pageId: '91009',
    buttonId: '91009001',
    extInfo: 'Market Profile-Stats-Mobile-Operation Data',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsMobileByGamesDownloadButton: {
    pageId: '91010',
    buttonId: '91010001',
    extInfo: 'Market Profile-Stats-Mobile-ByGames',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsMobileByGenresDownloadButton: {
    pageId: '91011',
    buttonId: '91011001',
    extInfo: 'Market Profile-Stats-Mobile-ByGenres',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsMobileByCompaniesDownloadButton: {
    pageId: '91012',
    buttonId: '91012001',
    extInfo: 'Market Profile-Stats-Mobile-ByCompanies',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsPCOperationDataDownloadButton: {
    pageId: '91013',
    buttonId: '91013001',
    extInfo: 'Market Profile-Stats-PC-Operation Data',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsPCByGamesDownloadButton: {
    pageId: '91014',
    buttonId: '91014001',
    extInfo: 'Market Profile-Stats-PC-ByGames',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsPCByGenresDownloadButton: {
    pageId: '91015',
    buttonId: '91015001',
    extInfo: 'Market Profile-Stats-PC-ByGenres',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsPCByCompaniesDownloadButton: {
    pageId: '91016',
    buttonId: '91016001',
    extInfo: 'Market Profile-Stats-PC-ByCompanies',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsConsoleOperationDataDownloadButton: {
    pageId: '91017',
    buttonId: '91017001',
    extInfo: 'Market Profile-Stats-Console-Operation Data',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsConsoleByGamesDownloadButton: {
    pageId: '91018',
    buttonId: '91018001',
    extInfo: 'Market Profile-Stats-Console-ByGames',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsConsoleByGenresDownloadButton: {
    pageId: '91019',
    buttonId: '91019001',
    extInfo: 'Market Profile-Stats-Console-ByGenres',
    typeId: typeIdObj.intelligence,
  },
  MarketProfileStatsConsoleByCompaniesDownloadButton: {
    pageId: '91020',
    buttonId: '91020001',
    extInfo: 'Market Profile-Stats-Console-ByCompanies',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileMobileGamesMainGenreDownloadButton: {
    pageId: '303401',
    buttonId: '303401001',
    extInfo: 'Genre Profile-Mobile Games-MainGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileMobileGamesSubGenreDownloadButton: {
    pageId: '303402',
    buttonId: '303402001',
    extInfo: 'Genre Profile-Mobile Games-SubGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileMobileGamesMainsubGenreDownloadButton: {
    pageId: '303403',
    buttonId: '303403001',
    extInfo: 'Genre Profile-Mobile Games-MainsubGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfilePCGamesMainGenreDownloadButton: {
    pageId: '303404',
    buttonId: '303404001',
    extInfo: 'Genre Profile-PC Games-MainGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfilePCGamesSubGenreDownloadButton: {
    pageId: '303405',
    buttonId: '303405001',
    extInfo: 'Genre Profile-PC Games-SubGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfilePCGamesMainsubGenreDownloadButton: {
    pageId: '303406',
    buttonId: '303406001',
    extInfo: 'Genre Profile-PC Games-MainsubGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileConsoleGamesMainGenreDownloadButton: {
    pageId: '303407',
    buttonId: '303407001',
    extInfo: 'Genre Profile-Console Games-MainGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileConsoleGamesSubGenreDownloadButton: {
    pageId: '303408',
    buttonId: '303408001',
    extInfo: 'Genre Profile-Console Games-SubGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileConsoleGamesMainsubGenreDownloadButton: {
    pageId: '303409',
    buttonId: '303409001',
    extInfo: 'Genre Profile-Console Games-MainsubGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileTotalGamesMainGenreDownloadButton: {
    pageId: '303410',
    buttonId: '303410001',
    extInfo: 'Genre Profile-Total Games-MainGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileTotalGamesSubGenreDownloadButton: {
    pageId: '303411',
    buttonId: '303411001',
    extInfo: 'Genre Profile-Total Games-SubGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileTotalGamesMainsubGenreDownloadButton: {
    pageId: '303412',
    buttonId: '303412001',
    extInfo: 'Genre Profile-Total Games-MainsubGenre',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsMobileGamesOperationDataDownloadButton: {
    pageId: '303421',
    buttonId: '303421001',
    extInfo: 'Genre Profile-Stats-Mobile Games-Operation Data',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsMobileGamesByGamesDownloadButton: {
    pageId: '303422',
    buttonId: '303422001',
    extInfo: 'Genre Profile-Stats-Mobile Games-ByGames',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsMobileGamesByCountriesDownloadButton: {
    pageId: '303423',
    buttonId: '303423001',
    extInfo: 'Genre Profile-Stats-Mobile Games-ByCountries',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsMobileGamesByCompaniesDownloadButton: {
    pageId: '303424',
    buttonId: '303424001',
    extInfo: 'Genre Profile-Stats-Mobile Games-ByCompanies',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsPCGamesOperationDataDownloadButton: {
    pageId: '303425',
    buttonId: '303425001',
    extInfo: 'Genre Profile-Stats-PC Games-Operation Data',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsPCGamesByGamesDownloadButton: {
    pageId: '303426',
    buttonId: '303426001',
    extInfo: 'Genre Profile-Stats-PC Games-ByGames',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsPCGamesByCountriesDownloadButton: {
    pageId: '303427',
    buttonId: '303427001',
    extInfo: 'Genre Profile-Stats-PC Games-ByCountries',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsPCGamesByCompaniesDownloadButton: {
    pageId: '303428',
    buttonId: '303428001',
    extInfo: 'Genre Profile-Stats-PC Games-ByCompanies',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsConsoleGamesOperationDataDownloadButton: {
    pageId: '303429',
    buttonId: '303429001',
    extInfo: 'Genre Profile-Stats-Console Games-Operation Data',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsConsoleGamesByGamesDownloadButton: {
    pageId: '303430',
    buttonId: '303430001',
    extInfo: 'Genre Profile-Stats-Console Games-ByGames',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsConsoleGamesByCountriesDownloadButton: {
    pageId: '303431',
    buttonId: '303431001',
    extInfo: 'Genre Profile-Stats-Console Games-ByCountries',
    typeId: typeIdObj.intelligence,
  },
  GenreProfileStatsConsoleGamesByCompaniesDownloadButton: {
    pageId: '303432',
    buttonId: '303432001',
    extInfo: 'Genre Profile-Stats-Console Games-ByCompanies',
    typeId: typeIdObj.intelligence,
  },

  CompareMobileGamesActiveUsersDownloadButton: {
    pageId: '302501',
    buttonId: '302501001',
    extInfo: 'Compare-Mobile Games-Active Users',
    typeId: typeIdObj.intelligence,
  },
  CompareMobileGamesDownloadsDownloadButton: {
    pageId: '302502',
    buttonId: '302502001',
    extInfo: 'Compare-Mobile Games-Downloads',
    typeId: typeIdObj.intelligence,
  },
  CompareMobileGamesRevenueDownloadButton: {
    pageId: '302503',
    buttonId: '302503001',
    extInfo: 'Compare-Mobile Games-Revenue',
    typeId: typeIdObj.intelligence,
  },
  CompareMobileGamesStoreRankDownloadButton: {
    pageId: '302504',
    buttonId: '302504001',
    extInfo: 'Compare-Mobile Games-Store Rank',
    typeId: typeIdObj.intelligence,
  },

  CompareMultidimensionDownloadButton: {
    pageId: '300410',
    buttonId: '300410001',
    extInfo: 'Compare-Multi-dimension',
    typeId: typeIdObj.intelligence,
  },

  PotentialNewReleaseGamesMobileGamesDownloadButton: {
    pageId: '300201',
    buttonId: '300201001',
    extInfo: 'Potential-New Release Games-Mobile Games',
    typeId: typeIdObj.intelligence,
  },
  PotentialNewReleaseGamesPCGamesDownloadButton: {
    pageId: '300202',
    buttonId: '300202001',
    extInfo: 'Potential-New Release Games-PC Games',
    typeId: typeIdObj.intelligence,
  },
  PotentialNewReleaseGamesConsoleGamesDownloadButton: {
    pageId: '300203',
    buttonId: '300203001',
    extInfo: 'Potential-New Release Games-ConsoleGames',
    typeId: typeIdObj.intelligence,
  },
  PotentialUpcomingGamesMobileGamesDownloadButton: {
    pageId: '300301',
    buttonId: '300301001',
    extInfo: 'Potential-Upcoming Games-Mobile Games',
    typeId: typeIdObj.intelligence,
  },
  PotentialUpcomingGamesPCGamesDownloadButton: {
    pageId: '300302',
    buttonId: '300302001',
    extInfo: 'Potential-Upcoming Games-PC Games',
    typeId: typeIdObj.intelligence,
  },
  PotentialUpcomingGamesConsoleGamesDownloadButton: {
    pageId: '300303',
    buttonId: '300303001',
    extInfo: 'Potential-Upcoming Games-Console Games',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesStatsDigitalRevenueDownloadButton: {
    pageId: '302101',
    buttonId: '302101001',
    extInfo: 'Top Charts-Console Games-Stats-Digital Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesStatsGSDSaleDataDownloadButton: {
    pageId: '302105',
    buttonId: '302105001',
    extInfo: 'Top Charts-Console Games-Stats-GSD Sale Data',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesStatsPhysicalRevenueDownloadButton: {
    pageId: '302102',
    buttonId: '302102001',
    extInfo: 'Top Charts-Console Games-Stats-Physical Revenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesStatsJapanSalesDownloadButton: {
    pageId: '302103',
    buttonId: '302103001',
    extInfo: 'Top Charts-Console Games-Stats-Japan Sales',
    typeId: typeIdObj.intelligence,
  },
  TopChartsConsoleGamesStatsNewzooMetricsDownloadButton: {
    pageId: '302104',
    buttonId: '302104001',
    extInfo: 'Top Charts-Console Games-Stats-No Update',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesCountriesDigitalRevenueDownloadButton: {
    pageId: '304001',
    buttonId: '304001001',
    extInfo: 'Top Charts-PC And Console Games-Countries-DigitalRevenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesCountriesGSDSaleDataDownloadButton: {
    pageId: '304006',
    buttonId: '304006001',
    extInfo: 'Top Charts-PC And Console Games-Countries-GSDSaleData',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesCountriesSteamDataDownloadButton: {
    pageId: '304004',
    buttonId: '304004001',
    extInfo: 'Top Charts-PC And Console Games-Countries-SteamData',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesCountriesUserEngagementDownloadButton: {
    pageId: '304007',
    buttonId: '304007001',
    extInfo: 'Top Charts-PC And Console Games-Countries-UserEngagement',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesCountriesPhysicalRevenueDownloadButton: {
    pageId: '304002',
    buttonId: '304002001',
    extInfo: 'Top Charts-PC And Console Games-Countries-PhysicalRevenue',
    typeId: typeIdObj.intelligence,
  },
  TopChartsPCAndConsoleGamesCountriesNewzooMetricsDownloadButton: {
    pageId: '304005',
    buttonId: '304005001',
    extInfo: 'Top Charts-PC And Console Games-Countries-No Update',
    typeId: typeIdObj.intelligence,
  },
  /**
   * 休闲专区-品类画像 下载
   */
  casualGenreProfileDownload: {
    pageId: '309899',
    buttonId: '309899001',
    extInfo: '休闲专区-品类画像下载',
    typeId: typeIdObj.intelligence,
  },
  /**
   * 选择异动指标
   * 比较特殊，打点时需要补充pageId，因为pageId是动态的
   */
  surgeMetricSelect: {
    pageId: '',
    buttonId: '999999001',
    extInfo: '选择异动指标',
    typeId: typeIdObj.intelligence,
  },
  menuSearchSelect: {
    pageId: '',
    buttonId: '999999002',
    extInfo: '菜单搜索选择菜单',
    typeId: typeIdObj.intelligence,
  },
};

// KPI Trends Filter Logging Configuration
export const kpiTrendsFilterLogConfig = {
  myFilter: {
    pageId: '303908',
    buttonId: '303908001',
    typeId: typeIdObj.intelligence,
    filterKey: MY_FILTER,
    valueExtractor: (prev: any, curr: any) => {
      const prevValue = prev?.value;
      const currValue = curr?.value;
      if (prevValue !== currValue && currValue) {
        return {
          selector: {
            selectedValue: currValue,
            selectedLabel: currValue,
          },
        };
      }
      return null;
    },
  },
  rangeTime: {
    pageId: '303908',
    buttonId: '303908002',
    typeId: typeIdObj.intelligence,
    filterKey: RANGE_TIME,
    valueExtractor: (prev: any, curr: any) => {
      if (prev?.type !== curr?.type || JSON.stringify(prev?.value) !== JSON.stringify(curr?.value)) {
        return {
          dateType: curr?.type,
          startDate: curr?.value?.[0] || undefined,
          endDate: curr?.value?.[1] || undefined,
        };
      }
      return null;
    },
  },
  metricSelectForKpiTrend: {
    pageId: '303908',
    buttonId: '303908003',
    typeId: typeIdObj.intelligence,
    filterKey: METRIC_SELECT_FOR_KPI_TREND,
    valueExtractor: (prev: any, curr: any) => {
      const componentValue = {
        Granularity: curr?.value?.type,
        'Metric Type': curr?.value?.types,
        Sources: curr?.value?.sources,
        Specific_Metrics: curr?.value?.metrics,
      };

      return componentValue;
    },
  },
  // Sub-config: metric selection metric type toggle
  metricSelectForKpiTrendMetricType: {
    pageId: '303908',
    buttonId: '303908014',
    typeId: typeIdObj.intelligence,
    filterKey: METRIC_SUBKEY_METRIC_TYPE,
    valueExtractor: (prev: any, curr: any) => {
      const prevSelected = prev?.value?.selectedMetricsValue || prev?.selectedMetricsValue;
      const currSelected = curr?.value?.selectedMetricsValue || curr?.selectedMetricsValue;
      if (prevSelected !== currSelected && currSelected) {
        return {
          selectedMetricsValue: currSelected,
        };
      }
      return null;
    },
  },
  // Sub-config: metric selection shot for metrics side
  metricSelectForKpiTrendShotMetric: {
    pageId: '303908',
    buttonId: '303908015',
    typeId: typeIdObj.intelligence,
    filterKey: METRIC_SUBKEY_SHOT_METRIC,
    valueExtractor: (prev: any, curr: any) => {
      const prevShot = prev?.value?.shotSelectValue || prev?.shotSelectValue;
      const currShot = curr?.value?.shotSelectValue || curr?.shotSelectValue;
      if (JSON.stringify(prevShot) !== JSON.stringify(currShot) && currShot) {
        return {
          shotSelectValue: currShot,
        };
      }
      return null;
    },
  },
  // Sub-config: metric selection shot for data source side
  metricSelectForKpiTrendShotDataSource: {
    pageId: '303908',
    buttonId: '303908016',
    typeId: typeIdObj.intelligence,
    filterKey: METRIC_SUBKEY_SHOT_DATA_SOURCE,
    valueExtractor: (prev: any, curr: any) => {
      const prevShot = prev?.value?.shotSelectValue || prev?.shotSelectValue;
      const currShot = curr?.value?.shotSelectValue || curr?.shotSelectValue;
      if (JSON.stringify(prevShot) !== JSON.stringify(currShot) && currShot) {
        return {
          shotSelectValue: currShot,
        };
      }
      return null;
    },
  },
  gsdFilter: {
    pageId: '303908',
    buttonId: '303908004',
    typeId: typeIdObj.intelligence,
    filterKey: PUBLISHER,
    valueExtractor: (prev: any, curr: any) => {
      const prevValue = prev?.value;
      const currValue = curr?.value;
      if (prevValue !== currValue && currValue) {
        return {
          selectedValue: currValue,
        };
      }
      return null;
    },
  },
  region: {
    pageId: '303908',
    buttonId: '303908005',
    typeId: typeIdObj.intelligence,
    filterKey: REGION,
    valueExtractor: (prev: any, curr: any) => {
      const prevRegions = prev?.regions;
      const currRegions = curr?.regions;
      if (JSON.stringify(prevRegions) !== JSON.stringify(currRegions) && currRegions) {
        return {
          selectedRegions: currRegions,
        };
      }
      return null;
    },
  },
  digitalSegmentMultiple: {
    pageId: '303908',
    buttonId: '303908006',
    typeId: typeIdObj.intelligence,
    filterKey: DIGITAL_SEGMENT_MULTIPLE,
    valueExtractor: (prev: any, curr: any) => {
      const prevValue = prev?.value;
      const currValue = curr?.value;
      if (JSON.stringify(prevValue) !== JSON.stringify(currValue) && currValue) {
        return {
          selectedSegments: currValue,
        };
      }
      return null;
    },
  },
  platform: {
    pageId: '303908',
    buttonId: '303908007',
    typeId: typeIdObj.intelligence,
    filterKey: PLATFORMCASCADER,
    valueExtractor: (prev: any, curr: any) => {
      const prevValue = prev?.value;
      const currValue = curr?.value;
      if (JSON.stringify(prevValue) !== JSON.stringify(currValue) && currValue) {
        return {
          selectedPlatforms: currValue,
        };
      }
      return null;
    },
  },
  cascader: {
    pageId: '303908',
    buttonId: '303908008',
    typeId: typeIdObj.intelligence,
    filterKey: CASCADER,
    valueExtractor: (prev: any, curr: any) => {
      const prevValue = prev?.value;
      const currValue = curr?.value;
      if (JSON.stringify(prevValue) !== JSON.stringify(currValue) && currValue) {
        return {
          selectedSources: currValue,
        };
      }
      return null;
    },
  },
  visualizationMetrics: {
    pageId: '303908',
    buttonId: '303908009',
    typeId: typeIdObj.intelligence,
    filterKey: 'visualization_metrics',
    valueExtractor: (prev: any, curr: any) => {
      const prevValue = prev?.value;
      const currValue = curr?.value;
      if (JSON.stringify(prevValue) !== JSON.stringify(currValue) && currValue) {
        return {
          selectedMetrics: currValue,
        };
      }
      return null;
    },
  },
  byDeviceToggle: {
    pageId: '303908',
    buttonId: '303908010',
    typeId: typeIdObj.intelligence,
    filterKey: METRICTABLE_DEVICE,
    valueExtractor: (prev: any, curr: any) => {
      const prevValue = prev?.value;
      const currValue = curr?.value;
      if (prevValue !== currValue && typeof currValue === 'boolean') {
        return {
          isEnabled: currValue,
        };
      }
      return null;
    },
  },
  // Special action buttons
  downloadChart: {
    pageId: '303908',
    buttonId: '303908011',
    typeId: typeIdObj.intelligence,
  },
  saveFilterSetting: {
    pageId: '303908',
    buttonId: '303908012',
    typeId: typeIdObj.intelligence,
  },
  resetFilter: {
    pageId: '303908',
    buttonId: '303908013',
    typeId: typeIdObj.intelligence,
  },
};

// 注意tab值不一样 数据类型也不一样,重构临时用数据
export const list = {
  img: '',
  title: 'PUBG Mobile',
  selectObj: {
    num1: 4,
    num2: 6,
    svg1: 'a-select-icon',
    svg2: 'video-icon',
  },
  svg: 'other-icon',
  text: 'Release Date: 2023-03-01',
};

/**
 * 左侧菜单跳转到第三方页面的打点信息配置映射
 * 键：菜单id
 * 值：菜单跳转页面的打点信息配置
 */
export const dbiThirdPageLogMes: IRecord<IBuriedPointCfg> = {
  '3901': dbiPageLogMes.robloxAndFortnite,
  '3902': dbiPageLogMes.miniGameRankings,
};
